export const translations = {
  pt: {
    // Geral
    loading: 'Carregando...',
    error: 'Erro',
    success: 'Sucesso',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    save: 'Salvar',
    back: 'Voltar',
    next: 'Próximo',
    
    // Auth
    login: 'Entrar',
    register: 'Registrar',
    email: 'E-mail',
    password: 'Senha',
    name: 'Nome',
    alreadyHaveAccount: 'Já tem uma conta?',
    dontHaveAccount: 'Não tem uma conta?',
    loginWithGoogle: 'Entrar com Google',
    loginGoogleOnly: 'Esta conta usa login pelo Google. Por favor, entre com o Google.',
    loginError: 'Email ou senha inválidos',
    loginSuccess: 'Login realizado com sucesso!',
    registerSuccess: 'Conta criada com sucesso!',
    registerError: 'Erro ao criar conta',
    registerEmailExists: 'Este email já está cadastrado',
    
    // Dashboard
    dashboard: 'Painel',
    welcome: 'Bem-vindo',
    askQuestion: 'Faça uma pergunta sobre Direito...',
    send: 'Enviar',
    clearHistory: 'Limpar Histórico',
    clearConversation: 'Limpar Conversa',
    newConversation: 'Nova Conversa',
    conversationHistory: 'Histórico de Conversas',
    logout: 'Sair',
    language: 'Idioma',
    aiAssistant: 'Assistente de IA Jurídica',
    typeMessage: 'Digite sua mensagem...',
    
    // Navigation
    questions: 'Questões',
    quiz: 'Quiz Educativo',
    mindMaps: 'Mapas Mentais',
    ebooks: 'E-books',
    myLibrary: '',
    subscription: 'Assinatura',
    
    // E-books
    ebooksTitle: 'Biblioteca de E-books Jurídicos',
    ebooksDescription: 'E-books especializados por apenas R$ 25,00 cada',
    subscriberAccess: 'Acesso ilimitado a todos os e-books',
    subscriberAccessDesc: 'Sua assinatura inclui acesso gratuito a toda a biblioteca de e-books',
    ebooksSubtitle: 'Materiais didáticos completos para seus estudos',
    allAreas: 'Todos',
    free: 'Grátis',
    buy: 'Comprar',
    read: 'Ler',
    noEbooksFound: 'Nenhum e-book encontrado',
    searchPlaceholder: 'Buscar por título, área ou descrição...',
    
    // Landing Page
    heroTitle: 'Estude Direito com Inteligência Artificial',
    heroDescription: 'Tire suas dúvidas jurídicas com nossa IA especializada em Direito brasileiro',
    howItWorks: 'Como Funciona',
    featuresTitle: 'Recursos Exclusivos',
    aiAssistantFeature: 'Assistente IA Jurídica',
    aiAssistantDesc: 'Chat inteligente para tirar dúvidas sobre Direito',
    ebooksFeature: 'E-books Especializados',
    ebooksFeatureDesc: 'Biblioteca completa de materiais didáticos',
    quizFeature: 'Quiz Interativo',
    quizFeatureDesc: 'Teste seus conhecimentos com questões',
    mindMapsFeature: 'Mapas Mentais',
    mindMapsFeatureDesc: 'Visualize conceitos de forma clara',
    pricingTitle: 'Escolha seu Plano',
    pricingSubtitle: 'Planos flexíveis para seu estudo',
    mostPopular: 'Mais Popular',
    objectiveExamples: 'Exemplos objetivos',
    basicSupport: 'Suporte básico',
    premiumSummaries: 'Resumos premium',
    bookRecommendations: 'Indicação de livros',
    advancedExamples: 'Exemplos avançados',
    everythingInMonthly: 'Tudo do Mensal',
    save79: 'Economia de 79%',
    exclusiveContent: 'Conteúdo exclusivo',
    popularTopics: 'Tópicos Populares',
    topicUsucapiao: 'Usucapião',
    topicPosse: 'Posse',
    topicPropriedade: 'Propriedade',
    topicPena: 'Pena',
    topicDolo: 'Dolo',
    topicCulpa: 'Culpa',
    topicObrigacoes: 'Obrigações',
    topicContratos: 'Contratos',
    topicSucessao: 'Sucessão',
    topicFamilia: 'Família',

    // Subscription Page
    subActivatedSuccess: 'Assinatura ativada com sucesso!',
    aiAccess: 'Acesso a IA especializada',
    prioritySupport: 'Suporte prioritário',
    earlyAccess: 'Acesso antecipado a novos recursos',
    professionalAnswers: 'Respostas profissionais de ponta',
    payOnceYear: 'Só paga uma vez por ano',
    subCurrentPlan: 'Plano Atual',
    subUpgradeFreeHint: 'Faça upgrade para desbloquear recursos premium',
    premiumFeatures: 'Recursos Premium',
    subChoosePlan: 'Escolha seu Plano',
    subAccelerateStudies: 'Acelere seus estudos com recursos avançados de IA',
    subSubscribeNow: 'Assinar Agora',
    subPlanActive: 'Plano Ativo',
    subWhyUpgrade: 'Por que fazer upgrade?',
    subBenefit1Title: 'Resumos Premium',
    subBenefit1Desc: 'Conteúdo mais detalhado, exemplos práticos e explicações aprofundadas',
    subBenefit2Title: 'Pesquisa Ilimitada',
    subBenefit2Desc: 'Sem limites de consultas. Pesquise quantas vezes precisar',
    subBenefit3Title: 'Bibliografia',
    subBenefit3Desc: 'Indicações de livros e referências especializadas',
    subModalTitle: 'Finalizar Assinatura Premium',
    subModalItemTitleWeekly: 'Assinatura Semanal',
    subModalItemTitleMonthly: 'Assinatura Mensal',
    subModalItemTitleAnnual: 'Assinatura Anual',

    // Mercado Pago Checkout
    mpPublicKeyMissing: 'Chave pública do Mercado Pago não configurada',
    mpInitError: 'Erro ao carregar sistema de pagamento. Tente recarregar a página.',
    mpInitErrorToast: 'Erro ao inicializar pagamento',
    mpPaymentApproved: 'Pagamento aprovado!',
    mpPaymentPending: 'Pagamento pendente. Aguardando confirmação.',
    mpPaymentNotApproved: 'Pagamento não foi aprovado. Tente novamente.',
    mpPaymentError: 'Erro ao processar pagamento',
    mpMustBeLoggedIn: 'Você precisa estar logado',
    mpPixGenerated: 'PIX gerado com sucesso!',
    mpQrNotGenerated: 'QR Code não foi gerado. Tente novamente.',
    mpPixError: 'Erro ao gerar PIX',
    mpBoletoGenerated: 'Boleto gerado com sucesso!',
    mpBoletoNotGenerated: 'Boleto não foi gerado. Tente novamente.',
    mpBoletoError: 'Erro ao gerar Boleto',
    mpNotConfiguredTitle: 'Sistema de Pagamento Não Configurado',
    mpNotConfiguredDesc: 'A chave pública do Mercado Pago não foi encontrada.',
    mpNotConfiguredEnvHint: 'Configure REACT_APP_MERCADO_PAGO_PUBLIC_KEY no arquivo .env',
    mpChooseMethodTitle: 'Escolha o Método de Pagamento',
    mpSelectHowToPay: 'Selecione como deseja pagar:',
    mpAutoRenewal: 'Renovação automática',
    mpImmediateApproval: 'Aprovação imediata',
    mpOneTimeMonthlyPayment: 'Pagamento único mensal',
    mpOneTimeWeeklyPayment: 'Pagamento único semanal',
    mpOneTimeAnnualPayment: 'Pagamento único anual',
    mpInstantPayment: 'Pagamento instantâneo',
    mpDueIn3Days: 'Vence em 3 dias',
    mpPaymentSystemErrorTitle: 'Erro no Sistema de Pagamento',
    mpReloadPage: 'Recarregar Página',
    mpLoadingPaymentSystem: 'Carregando sistema de pagamento...',
    mpPleaseWait: 'Por favor, aguarde',
    mpCardProcessError: 'Erro ao processar cartão. Tente novamente.',
    mpGeneratingPix: 'Gerando PIX...',
    mpGeneratePix: 'Gerar PIX',
    mpPixSuccessTitle: 'PIX Gerado com Sucesso!',
    mpPixCodeLabel: 'Código PIX (Copiar e Colar):',
    mpCodeCopied: 'Código copiado!',
    mpCopy: 'Copiar',
    mpPixImportantTitle: 'Importante sobre Pagamento via PIX',
    mpPixOnceNotAutoRenewed: 'O pagamento via PIX é único e NÃO renovado automaticamente. Você precisará pagar novamente quando o período expirar para manter sua assinatura ativa.',
    mpPixAutoRenewalPrefix: 'Para renovação automática, escolha',
    mpHowToPayTitle: 'Como pagar:',
    mpPixStep1: 'Abra o app do seu banco',
    mpPixStep2: 'Escolha pagar com PIX',
    mpPixStep3: 'Escaneie o QR Code ou cole o código',
    mpPixStep4Prefix: 'Confirme o pagamento de',
    mpPixProcessedInstantly: 'O pagamento é processado instantaneamente após a confirmação',
    mpAlreadyPaid: 'Já Paguei',
    mpBoletoWillBeGenerated: 'O boleto será gerado e você poderá pagá-lo em qualquer banco.',
    mpGeneratingBoleto: 'Gerando Boleto...',
    mpGenerateBoleto: 'Gerar Boleto',
    mpBoletoSuccessTitle: 'Boleto Gerado com Sucesso!',
    mpBoletoLineLabel: 'Linha Digitável do Boleto:',
    mpLineCopied: 'Linha digitável copiada!',
    mpValueLabel: 'Valor:',
    mpDueDateLabel: 'Vencimento:',
    mpBeneficiaryLabel: 'Beneficiário:',
    mpViewPrintBoleto: 'Visualizar/Imprimir Boleto',
    mpBoletoStep1: 'Copie a linha digitável acima',
    mpBoletoStep2: 'Acesse o app ou site do seu banco',
    mpBoletoStep3: 'Escolha "Pagar Boleto"',
    mpBoletoStep4: 'Cole a linha digitável',
    mpBoletoStep5: 'Confirme o pagamento até a data de vencimento',
    mpBoletoConfirmTime: 'O boleto leva de 1 a 3 dias úteis para ser confirmado após o pagamento',
    mpProcessingPayment: 'Processando pagamento...',

    // Auth Callback / Mind Map / Quiz Analytics
    authProcessing: 'Processando autenticação...',
    mmPdfSaved: 'PDF salvo com sucesso!',
    mmPdfError: 'Erro ao gerar PDF',
    mmLinkCopied: 'Link copiado!',
    mmLinkCreatedCopied: 'Link criado e copiado!',
    mmShareError: 'Erro ao gerar link de compartilhamento',
    mmLightMode: 'Claro',
    mmPrintMode: 'Impressão',
    mmCopied: 'Copiado!',
    mmCopyLink: 'Copiar',
    mmShare: 'Compartilhar',
    mmClose: 'Fechar',
    qaTrend: 'Tendência',
    qaImproving: 'Melhorando',
    qaAttention: 'Atenção',
    qaStable: 'Estável',
    qaScoreEvolution: 'Evolução das Notas',
    qaAccuracy: 'Acerto',
    qaPerformanceByArea: 'Desempenho por Área',

    // Shared Map / Shared Slides
    smMapNotFound: 'Mapa não encontrado ou link expirado.',
    smMapNotFoundFallback: 'Mapa não encontrado',
    smLinkIncorrectHint: 'O link pode estar incorreto ou o mapa foi removido.',
    smBackHome: 'Voltar ao Início',
    ssPresentationNotFound: 'Apresentação não encontrada ou link expirado.',
    ssInvalidLink: 'Link inválido',
    ssSharedPresentation: 'Apresentação Compartilhada',
    ssSlideLabel: 'Slide',
    ssPrevious: 'Anterior',
    ssNext: 'Próximo',
    ssFooterGenerated: 'Gerado por Law Study A.I — Use as setas do teclado para navegar',

    // Ebook Detail Page
    ebdNotFound: 'E-book não encontrado',
    ebdLoading: 'Carregando e-book...',
    ebdFreeBadge: 'GRATUITO',
    ebdLoginToBuy: 'Faça login para comprar e-books',
    ebdAddedToLibrary: 'E-book adicionado à sua biblioteca!',
    ebdPurchasedForPrefix: 'E-book comprado por',
    mocked: 'mockado',
    ebdPurchaseError: 'Erro ao comprar e-book',
    ebdActiveSubscription: 'Assinatura ativa — acesso completo',
    ebdReadEbook: 'Ler E-book',
    ebdViewAllEbooks: 'Ver Todos os E-books',
    ebdLoginToBuySimple: 'Faça login para comprar',
    ebdGetFree: 'Obter Grátis',
    ebdBuyNow: 'Comprar Agora',
    ebdLoginLink: 'Faça login',
    ebdToBuyThisEbook: 'para comprar este e-book',
    ebdPurchaseSuccess: 'Compra realizada com sucesso!',
    ebdWhatYouWillLearn: 'O que você vai aprender:',
    ebdFeature1: 'Conteúdo especializado e didático',
    ebdFeature2: 'Exemplos práticos e casos reais',
    ebdFeature3: 'Legislação atualizada',
    ebdFeature4: 'Acesso vitalício após compra',

    // Atualizações Jurídicas (list + detail)
    audNotFound: 'Atualização não encontrada',
    audLoginToFavorite: 'Faça login para favoritar',
    audFavoriteError: 'Erro ao favoritar',
    audLinkCopied: 'Link copiado!',
    audTypeNoticia: 'Notícia',
    audTypeLegislacao: 'Legislação',
    audTypeJurisprudencia: 'Jurisprudência',
    audTypeArtigo: 'Artigo',
    audBrazilianLaw: 'Direito Brasileiro',
    audInternationalLaw: 'Direito Internacional',
    audSourceLabel: 'Fonte:',
    audViewOriginalSource: 'Ver fonte original',
    audFavorited: 'Favoritado',
    audFavoriteAction: 'Favoritar',
    audBackToUpdates: 'Voltar para atualizações',
    ajErrorLoading: 'Erro ao carregar atualizações',
    ajLoginToFavorite: 'Faça login para favoritar atualizações',
    ajAddedToFavorites: 'Adicionado aos favoritos',
    ajRemovedFromFavorites: 'Removido dos favoritos',
    ajNewUpdatesAdded: 'novas atualizações adicionadas!',
    ajNoNewUpdates: 'Nenhuma atualização nova encontrada',
    ajSyncError: 'Erro ao sincronizar notícias',
    ajLoadingUpdates: 'Carregando atualizações...',
    ajPageTitle: 'Atualizações Jurídicas',
    ajPageSubtitle: 'Conteúdos jurídicos de Direito Brasileiro e Internacional sempre atualizados',
    ajSearchPlaceholder: 'Buscar atualizações...',
    ajHideFilters: 'Ocultar Filtros',
    ajShowFilters: 'Mostrar Filtros',
    ajSearching: 'Buscando...',
    ajSearchNews: 'Buscar Notícias',
    ajCategory: 'Categoria',
    ajAll: 'Todas',
    ajType: 'Tipo',
    ajArea: 'Área',
    ajAreaCivil: 'Direito Civil',
    ajAreaPenal: 'Direito Penal',
    ajAreaLabor: 'Direito Trabalhista',
    ajAreaConstitutional: 'Direito Constitucional',
    ajAreaAdministrative: 'Direito Administrativo',
    ajAreaTax: 'Direito Tributário',
    ajAreaInternational: 'Direito Internacional',
    ajClearFilters: 'Limpar Filtros',
    ajUpdatesFound: 'atualizações encontradas',
    ajBrazilShort: 'Brasileiro',
    ajInternationalShort: 'Internacional',
    ajReadOriginalSource: 'Ler fonte original',
    ajNoUpdatesFound: 'Nenhuma atualização encontrada',
    ajTryAdjustingFilters: 'Tente ajustar os filtros ou buscar por outros termos',

    // Quiz Page
    qzLoginRequired: 'Por favor, faça login para acessar os quizzes',
    qzFillAllFields: 'Por favor, preencha todos os campos',
    qzGeneratedSuccess: 'Quiz gerado com sucesso!',
    qzGenerateError: 'Erro ao gerar quiz',
    qzSelectAnswer: 'Selecione uma resposta',
    qzCompletedToastPrefix: 'Quiz concluído! Você acertou',
    qzOf: 'de',
    qzQuestionsWord: 'questões',
    qzSubmitError: 'Erro ao submeter quiz',
    qzHistoryError: 'Erro ao carregar histórico',
    qzBack: 'Voltar',
    qzViewHistory: 'Ver Histórico',
    qzTitle: 'Quiz Educativo',
    qzSubtitle: 'Teste seus conhecimentos e aprenda com explicações detalhadas',
    qzAreaLabel: 'Área do Direito',
    qzSelectArea: 'Selecione a área',
    qzQuestionTypeLabel: 'Tipo de Questões',
    qzSelectType: 'Selecione o tipo',
    qzMultipleChoice: 'Múltipla Escolha',
    qzTrueFalse: 'Verdadeiro ou Falso',
    qzMixed: 'Misto (Ambos)',
    qzDifficultyLabel: 'Nível de Dificuldade',
    qzSelectLevel: 'Selecione o nível',
    qzBasic: 'Básico',
    qzIntermediate: 'Intermediário',
    qzAdvanced: 'Avançado',
    qzNumQuestionsLabel: 'Número de Questões',
    qzGenerating: 'Gerando Quiz...',
    qzGenerateBtn: 'Gerar Quiz',
    qzQuestionWord: 'Questão',
    qzPreviousBtn: 'Anterior',
    qzFinishQuiz: 'Finalizar Quiz',
    qzNextBtn: 'Próxima',
    qzCompletedTitle: 'Quiz Concluído!',
    qzYouGot: 'Você acertou',
    qzExcellent: 'Excelente!',
    qzGoodJob: 'Bom trabalho!',
    qzKeepStudying: 'Continue estudando!',
    qzYourAnswer: 'Sua resposta:',
    qzCorrectAnswer: 'Resposta correta:',
    qzExplanationLabel: 'Explicação:',
    qzNewQuiz: 'Novo Quiz',
    qzGeneralStats: 'Estatísticas Gerais',
    qzStatQuizzes: 'Quizzes',
    qzStatCorrect: 'Acertos',
    qzStatQuestions: 'Questões',
    qzStatPerformance: 'Aproveitamento',
    qzHistoryTitle: 'Histórico de Quizzes',
    qzNoQuizzesYet: 'Nenhum quiz realizado ainda',
    qzFirstQuiz: 'Fazer Primeiro Quiz',
    qzVF: 'V/F',
    qzRestrictedAccess: 'Acesso Restrito',
    qzLoginToAccess: 'Você precisa fazer login para acessar os quizzes educativos',
    qzDoLogin: 'Fazer Login',
    qzAreaBusiness: 'Direito Empresarial',
    qzAreaCivilProcedure: 'Direito Processual Civil',
    qzAreaCriminalProcedure: 'Direito Processual Penal',
    qzAreaConsumer: 'Direito do Consumidor',
    
    // Payment
    paymentMethods: 'Métodos de Pagamento',
    pix: 'PIX',
    creditCard: 'Cartão de Crédito',
    boleto: 'Boleto',
    
    // Quiz
    quizTitle: 'Quiz Educativo',
    selectArea: 'Selecione a Área',
    selectType: 'Tipo de Questões',
    selectLevel: 'Nível de Dificuldade',
    numberOfQuestions: 'Número de Questões',
    startQuiz: 'Iniciar Quiz',
    
    // Mind Maps
    mindMapsTitle: 'Mapas Mentais Jurídicos',
    mindMapsDescription: 'Resumos visuais dos principais temas do Direito',
    
    // Subscription
    subscriptionPlans: 'Planos de Assinatura',
    weekly: 'Semanal',
    monthly: 'Mensal',
    annual: 'Anual',
    subscribe: 'Assinar',
    
    // Landing Page
    landingTitle: 'Simplifique seus Estudos Jurídicos',
    landingSubtitle: 'Plataforma de IA para estudantes de Direito',
    getStarted: 'Começar Agora',
    features: 'Recursos',
    pricing: 'Preços',
    
    // More sections
    premiumAccess: 'Acesso Premium',
    unlimitedSearch: 'Buscas ilimitadas',
    detailedSummaries: 'Resumos detalhados',
    practicalExamples: 'Exemplos práticos',
    specializedBibliography: 'Bibliografia especializada',
    perWeek: 'por semana',
    perMonth: 'por mês',
    perYear: 'por ano',
    chooseArea: 'Escolha a Área',
    difficulty: 'Dificuldade',
    basic: 'Básico',
    intermediate: 'Intermediário',
    advanced: 'Avançado',
    correct: 'Correto',
    incorrect: 'Incorreto',
    score: 'Pontuação',
    total: 'Total',
    explanation: 'Explicação',
    continue: 'Continuar',
    finish: 'Finalizar',
    results: 'Resultados',
    yourScore: 'Sua Pontuação',
    correctAnswers: 'Respostas Corretas',
    viewDetails: 'Ver Detalhes',
    tryAgain: 'Tentar Novamente',
    backToDashboard: 'Voltar ao Painel',
    purchase: 'Comprar',
    price: 'Preço',
    lifetimeAccess: 'Acesso vitalício',
    paymentMethod: 'Método de Pagamento',
    processing: 'Processando...',
    purchased: 'Comprado',
    alreadyPurchased: 'Já Comprado',
    scanQRCode: 'Escaneie o QR Code',
    copyCode: 'Copiar Código',
    alreadyPaid: 'Já Paguei',
    generating: 'Gerando...',
    viewLibrary: 'Ver Biblioteca',
    noItems: 'Nenhum item',
    history: 'Histórico',
    statistics: 'Estatísticas',
    attempts: 'Tentativas',
    averageScore: 'Pontuação Média',
    byArea: 'Por Área',
    backToHome: 'Voltar para início',
    orSeparator: 'ou',
    legalUpdates: 'Atualizações Jurídicas',
    choosePlan: 'Escolher Plano',

    // Criar Page
    criarTitle: 'Criar',
    criarPecasProcessuais: 'Peças Processuais',
    criarApresentacoes: 'Apresentações',
    criarNovoDocumento: 'Novo Documento',
    criarNenhumDocumento: 'Nenhum documento ainda',
    criarGerarPeca: 'Gerar Peça Processual',
    criarGerarPecaDesc: 'Preencha os dados e a IA criará a peça completa com fundamentação jurídica real',
    criarGerarApresentacao: 'Gerar Apresentação',
    criarGerarApresentacaoDesc: 'Informe o tema jurídico e receba slides profissionais prontos para apresentar',
    criarTipoPeca: 'Tipo de Peça',
    criarSelecioneTipo: 'Selecione o tipo...',
    criarNomeAutor: 'Nome do Autor/Requerente',
    criarPlaceholderAutor: 'Ex: João da Silva',
    criarDadosAutor: 'Dados do Autor',
    criarPlaceholderDadosAutor: 'CPF, endereço, profissão...',
    criarNomeReu: 'Nome do Réu/Requerido',
    criarPlaceholderReu: 'Ex: Empresa XYZ Ltda.',
    criarDadosReu: 'Dados do Réu',
    criarPlaceholderDadosReu: 'CNPJ, endereço...',
    criarAutorNomeCompleto: 'Nome completo',
    criarAutorDocumento: 'CPF',
    criarPlaceholderAutorDoc: 'Ex: 123.456.789-00',
    criarAutorProfissao: 'Profissão',
    criarPlaceholderAutorProf: 'Ex: Comerciante',
    criarAutorEndereco: 'Endereço',
    criarPlaceholderAutorEnd: 'Rua, número, bairro, cidade/UF',
    criarReuNomeCompleto: 'Nome completo / Razão social',
    criarReuDocumento: 'CPF / CNPJ',
    criarPlaceholderReuDoc: 'Ex: 12.345.678/0001-99',
    criarReuEndereco: 'Endereço',
    criarPlaceholderReuEnd: 'Rua, número, bairro, cidade/UF',
    criarForo: 'Foro / Vara',
    criarPlaceholderForo: 'Ex: 3ª Vara Cível da Comarca de São Paulo/SP',
    criarSituacao: 'Situação / Fatos',
    criarPlaceholderSituacao: 'Descreva detalhadamente os fatos, o problema jurídico e o que deseja alcançar...',
    criarGerandoPeca: 'Gerando peça...',
    criarTemaApresentacao: 'Tema da Apresentação',
    criarPlaceholderTema: 'Ex: Princípios do Direito Penal Brasileiro',
    criarNumSlides: 'Número de Slides',
    criarDetalhesAdicionais: 'Detalhes Adicionais',
    criarPlaceholderDetalhes: 'Foco em jurisprudência? Nível acadêmico? Público-alvo?',
    criarGerandoApresentacao: 'Gerando apresentação...',
    criarAnterior: 'Anterior',
    criarProximo: 'Próximo',
    criarAutorLabel: 'Autor',
    criarReuLabel: 'Réu',
    criarForoLabel: 'Foro',
    criarPreenchaCampos: 'Preencha todos os campos obrigatórios',
    criarInformeTema: 'Informe o tema da apresentação',
    criarRecursoExclusivo: 'Recurso exclusivo para assinantes',
    criarPecaGerada: 'Peça processual gerada com sucesso!',
    criarErroPeca: 'Erro ao gerar peça',
    criarApresentacaoGerada: 'Apresentação gerada com sucesso!',
    criarErroSlides: 'Erro ao gerar slides',
    criarExportadoComo: 'Exportado como',
    criarErroExportar: 'Erro ao exportar documento',
    criarErroCarregar: 'Erro ao carregar documento',
    criarDocExcluido: 'Documento excluído',
    criarErroExcluir: 'Erro ao excluir',
    criarPeticaoInicial: 'Petição Inicial',
    criarContestacao: 'Contestação',
    criarApelacao: 'Apelação',
    criarMandadoSeguranca: 'Mandado de Segurança',
    criarHabeasCorpus: 'Habeas Corpus',
    criarRecursoEspecial: 'Recurso Especial',
    criarAgravo: 'Agravo de Instrumento',
    criarReconvencao: 'Reconvenção',
    criarEmbargosDeclaracao: 'Embargos de Declaração',
    criarAcaoIndenizacao: 'Ação de Indenização',
    criarSlides: 'slides',
    criarSalvarRascunho: 'Salvar Rascunho',
    criarRascunhoSalvo: 'Rascunho salvo com sucesso!',
    criarRascunhoAtualizado: 'Rascunho atualizado!',
    criarErroRascunho: 'Erro ao salvar rascunho',
    criarRascunhos: 'Rascunhos',
    criarRascunhoExcluido: 'Rascunho excluído',
    criarEditarRascunho: 'Editar rascunho',
    criarGerarDoRascunho: 'Gerar Peça deste Rascunho',
    criarSalvando: 'Salvando...',

    // Mapas Mentais Custom
    mapasCriar: 'Criar Mapa Mental',
    mapasTema: 'Tema do Mapa Mental',
    mapasPlaceholderTema: 'Ex: Direito Penal - Crimes contra a pessoa',
    mapasProfundidade: 'Nível de Profundidade',
    mapasBasico: 'Básico (3 tópicos)',
    mapasIntermediario: 'Intermediário (5 tópicos)',
    mapasAvancado: 'Avançado (7 tópicos)',
    mapasGerar: 'Gerar Mapa Mental',
    mapasGerando: 'Gerando mapa mental...',
    mapasGerado: 'Mapa mental gerado com sucesso!',
    mapasErro: 'Erro ao gerar mapa mental',
    mapasMeus: 'Meus Mapas',
    mapasExcluido: 'Mapa excluído',
    mapasNenhum: 'Nenhum mapa criado ainda',
    mapasAprendizado: 'Aprendizado Visual',
    mapasTitulo: 'Mapas Mentais Jurídicos',
    mapasDescricao: 'Resumos visuais dos principais temas do Direito com exemplos práticos e fáceis de entender',
    mapasComoUsar: 'Como usar os Mapas Mentais?',
    mapasTopicsCount: 'tópicos',
    mapasSubtopicsCount: 'subtópicos',
    mapasHowToUse1: 'Clique em "Visualizar" para ver o mapa mental em formato de árvore interativa',
    mapasHowToUse2: 'Passe o mouse sobre os nós para ver detalhes e exemplos',
    mapasHowToUse3: 'Use o botão PDF para salvar e imprimir seu mapa mental',
    ebooksLoadError: 'Erro ao carregar e-books',
    dashAnalyzeImage: 'Analisar imagem',
    dashHidePanel: 'Esconder painel',
    dashShowPanel: 'Mostrar painel',
    untitledConversation: 'Sem título',
    dashImageSentAlt: 'Imagem enviada',
    mapasFavoriteError: 'Erro ao favoritar',
    mapasConfirmDelete: 'Deseja excluir este mapa mental?',
    ebooksLoading: 'Carregando e-books...',
    erpMustPurchaseFirst: 'Você precisa comprar este e-book primeiro',
    erpLoadContentError: 'Erro ao carregar conteúdo',
    erpTranslationTimeout: 'Tempo limite de tradução excedido. Tente novamente.',
    erpTranslationServerError: 'Erro no servidor de tradução. Tente novamente mais tarde.',
    erpTranslatePageError: 'Erro ao traduzir página',
    erpEbookInPortuguese: 'E-book em Português',
    erpTranslatingTo: 'Traduzindo para',
    erpTranslationAppliedPerPage: 'A tradução será aplicada página por página',
    erpSelectLanguageForTranslation: 'Selecione o idioma para tradução',
    erpMainLanguages: 'Idiomas Principais',
    erpAsia: 'Ásia',
    erpEurope: 'Europa',
    erpAfrica: 'África',
    erpAmericasOceania: 'Américas & Oceania',
    erpOtherLanguages: 'Outras Línguas',
    erpTranslating: 'Traduzindo...',
    erpTranslatingContent: 'Traduzindo conteúdo...',
    erpChapter: 'Capítulo',
    erpPracticalExamples: 'Exemplos Práticos',
    erpPreviousPage: 'Página Anterior',
    erpNextPage: 'Próxima Página',
    erpNextChapter: 'Próximo',
    mapasClique: 'Clique nos tópicos para expandir e ver detalhes',
    mapasExemplo: 'Cada exemplo prático facilita a memorização',
    mapasGuia: 'Use como guia rápido de revisão antes das provas',
    mapasCarregando: 'Carregando mapas mentais...',
    mapasErroCarregar: 'Erro ao carregar mapas mentais',

    // Welcome / Dashboard dynamic
    welcomeTitle: 'Como posso ajudar?',
    welcomeSubtitle: 'Faça uma pergunta sobre qualquer tema jurídico',
    summarizeLegalText: 'Resumir Texto Jurídico',
    summarizeLegalTextDesc: 'Envie processos, petições, contestações, apelações ou questões de prova',
    images: 'Imagens',
    photos: 'Fotos',
    aiAnalysis: 'Análise com IA',
    premiumAnalysisActive: 'Análise Premium Ativada',
    eLawyerTitle: 'E-Lawyer - Advogado Virtual',
    eLawyerDesc: 'Consulte um advogado virtual especializado em TODAS as áreas do Direito',
    areaCivil: 'Civil',
    areaPenal: 'Penal',
    areaLabor: 'Trabalhista',
    areaConstitutional: 'Constitucional',
    areaAdministrative: 'Administrativo',
    areaTax: 'Tributário',
    andMore: 'E muito mais!',
    premiumConsultActive: 'Consultoria Premium Ativada - Respostas Especializadas',
    sessionExpired: 'Sessão expirada. Faça login novamente.',
    newConvStarted: 'Nova conversa iniciada',
    confirmDeleteConv: 'Deseja realmente excluir esta conversa?',
    convDeleted: 'Conversa excluída com sucesso!',
    errorDeleteConv: 'Erro ao excluir conversa',
    confirmClearAll: 'Deseja realmente limpar todo o histórico de conversas? Conversas favoritas serão mantidas.',
    historyCleared: 'Histórico limpo com sucesso!',
    errorClearHistory: 'Erro ao limpar histórico',
    addToFavorites: 'Adicionar aos favoritos',
    removeFromFavorites: 'Remover dos favoritos',
    addedToFavorites: 'Conversa adicionada aos favoritos',
    removedFromFavorites: 'Conversa removida dos favoritos',
    errorToggleFavorite: 'Erro ao favoritar conversa',
    noConversationsToClear: 'Nenhuma conversa para limpar',
    showFavoritesOnly: 'Mostrar apenas favoritas',
    showAllConversations: 'Mostrar todas as conversas',
    noFavoriteConversations: 'Nenhuma conversa favorita ainda',
    noConversationsYet: 'Nenhuma conversa ainda',
    noSearchResults: 'Nenhum resultado',
    unsupportedFormat: 'Formato não suportado. Use imagens (JPG, PNG) ou PDF',
    fileTooLarge: 'Arquivo muito grande. Máximo 10MB',
    analyzingDoc: 'Analisando documento...',
    premiumAnalysisDone: 'Análise Premium Concluída!',
    docAnalyzed: 'Documento Analisado!',
    errorAnalyzeDoc: 'Erro ao analisar documento. Tente novamente.',
    errorProcessQuestion: 'Erro ao processar pergunta',
    logoutSuccess: 'Logout realizado com sucesso',
    legalAssistant: 'Assistente Jurídico',
    eLawyerHeaderDesc: 'Consultoria jurídica especializada em todas as áreas do Direito',
    askAnythingAboutLaw: 'Pergunte qualquer dúvida sobre Direito',
    chatExportedPdf: 'Conversa exportada como PDF!',
    errorExportChat: 'Erro ao exportar conversa',
    fileSelected: 'Arquivo selecionado',
    addComment: 'Adicione um comentário (opcional)',
    sendFileForAnalysis: 'Enviar arquivo para análise',
    suggestion1: 'Explique o conceito de usucapião',
    suggestion2: 'Diferença entre dolo e culpa',
    suggestion3: 'Como calcular pena base?',
    suggestion4: 'O que é posse?',
    searchConversation: 'Buscar conversa...',
    errorAnswerRecord: 'Erro ao registrar resposta',
    filterByArea: 'Filtrar por área:',
    allAreas2: 'Todas as Áreas',
    questionOf: 'Questão',
    of: 'de',
    correctAnswer: 'Resposta Correta!',
    incorrectAnswer: 'Resposta Incorreta',
    completedAllQuestions: 'Você completou todas as questões desta área!',
    nextQuestion: 'Próxima Questão',
    completedAll: 'Você completou todas as questões!',
    loadingQuestions: 'Carregando questões...',
    noQuestionsFound: 'Nenhuma questão encontrada para esta área',
    viewAll: 'Ver Todas',
    accuracy: 'de acerto',
    loginToAccessQuestions: 'Faça login para acessar as questões',
    errorLoadQuestions: 'Erro ao carregar questões',
    docSent: 'Documento enviado',
    allRightsReserved: '© 2025 Law Study A.I. Todos os direitos reservados.',
    availableLanguages: 'Idiomas: Português, Inglês, Espanhol, Francês',
    
    // Ebook Index
    tableOfContents: 'Sumário',
    page: 'Página',
    
    // Presentation Mode  
    presentationMode: 'Apresentar',
    exitPresentation: 'Sair',
    pressEscToExit: 'Pressione ESC para sair',
    
    // Videos
    videosTitle: 'Vídeos Educativos',
    videosSubtitle: 'Gere vídeos animados sobre temas jurídicos com narração em áudio',
    videoPromptLabel: 'Descreva o tema do vídeo *',
    videoPromptPlaceholder: 'Ex: Explique o conceito de habeas corpus e quando pode ser utilizado...',
    videoLanguageLabel: 'Idioma do vídeo',
    videoSubtitlesLabel: 'Incluir legendas',
    videoDurationLabel: 'Duração do vídeo',
    videoGenerate: 'Gerar Vídeo',
    videoGenerating: 'Gerando...',
    videoHistory: 'Histórico',
    videoNoHistory: 'Nenhum vídeo gerado ainda',
    videoStatusQueued: 'Na fila',
    videoStatusScript: 'Gerando roteiro...',
    videoStatusAudio: 'Gerando narração...',
    videoStatusVideo: 'Gerando animação...',
    videoSceneLabel: 'Cena',
    videoSceneOfLabel: 'de',
    videoStatusMerging: 'Montando vídeo final...',
    videoStatusCompleted: 'Concluído',
    videoStatusError: 'Erro',
    videoSeconds: 'segundos',
    videoDeleteConfirm: 'Deseja realmente excluir este vídeo?',
    videoDeleted: 'Vídeo excluído',
    videoRetry: 'Tentar Novamente',
    videoRetryHint: 'Prompt copiado. Clique em Gerar para tentar novamente.',
    videoNarration: 'Roteiro da Narração',
    videoSubtitlesText: 'Legendas',
    videoSubtitlesToggle: 'Legendas',
    videoGenerateSuccess: 'Vídeo iniciado! Acompanhe o progresso abaixo.',
    videoGenerateError: 'Erro ao gerar vídeo',
    navVideos: 'Vídeos',
    videoShare: 'Compartilhar',
    videoCopyLink: 'Copiar Link',
    videoLinkCopied: 'Link Copiado!',
    videoDownload: 'Download',
    videoMinutes: 'minutos',
    galleryTitle: 'Galeria de Vídeos',
    gallerySubtitle: 'Explore vídeos educativos compartilhados pela comunidade',
    gallerySearch: 'Buscar por tema...',
    galleryEmpty: 'Nenhum vídeo na galeria ainda',
    galleryEmptyDesc: 'Seja o primeiro a compartilhar um vídeo educativo!',
    galleryCreateVideo: 'Criar Vídeo',
    navGallery: 'Galeria'
  },

  en: {
    // General
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    back: 'Back',
    next: 'Next',
    
    // Auth
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    alreadyHaveAccount: 'Already have an account?',
    dontHaveAccount: "Don't have an account?",
    loginWithGoogle: 'Login with Google',
    loginGoogleOnly: 'This account uses Google login. Please sign in with Google.',
    loginError: 'Invalid email or password',
    loginSuccess: 'Login successful!',
    registerSuccess: 'Account created successfully!',
    registerError: 'Error creating account',
    registerEmailExists: 'This email is already registered',
    welcome: 'Welcome',
    askQuestion: 'Ask a question about Law...',
    send: 'Send',
    clearHistory: 'Clear History',
    clearConversation: 'Clear Conversation',
    newConversation: 'New Conversation',
    conversationHistory: 'Conversation History',
    logout: 'Logout',
    language: 'Language',
    aiAssistant: 'Legal AI Assistant',
    typeMessage: 'Type your message...',
    
    // Navigation
    questions: 'Questions',
    quiz: 'Educational Quiz',
    mindMaps: 'Mind Maps',
    ebooks: 'E-books',
    myLibrary: '',
    subscription: 'Subscription',
    
    // E-books
    ebooksTitle: 'Legal E-books Library',
    ebooksDescription: 'Specialized e-books for only R$ 25.00 each',
    subscriberAccess: 'Unlimited access to all e-books',
    subscriberAccessDesc: 'Your subscription includes free access to the entire e-book library',
    ebooksSubtitle: 'Complete educational materials for your studies',
    allAreas: 'All',
    free: 'Free',
    buy: 'Buy',
    read: 'Read',
    noEbooksFound: 'No e-books found',
    searchPlaceholder: 'Search by title, area or description...',
    
    // Landing Page
    heroTitle: 'Study Law with Artificial Intelligence',
    heroDescription: 'Get answers to your legal questions with our AI specialized in Brazilian Law',
    howItWorks: 'How It Works',
    featuresTitle: 'Exclusive Features',
    aiAssistantFeature: 'Legal AI Assistant',
    aiAssistantDesc: 'Smart chat to answer legal questions',
    ebooksFeature: 'Specialized E-books',
    ebooksFeatureDesc: 'Complete library of educational materials',
    quizFeature: 'Interactive Quiz',
    quizFeatureDesc: 'Test your knowledge with questions',
    mindMapsFeature: 'Mind Maps',
    mindMapsFeatureDesc: 'Visualize concepts clearly',
    pricingTitle: 'Choose Your Plan',
    pricingSubtitle: 'Flexible plans for your studies',
    mostPopular: 'Most Popular',
    objectiveExamples: 'Objective examples',
    basicSupport: 'Basic support',
    premiumSummaries: 'Premium summaries',
    bookRecommendations: 'Book recommendations',
    advancedExamples: 'Advanced examples',
    everythingInMonthly: 'Everything in Monthly',
    save79: 'Save 79%',
    exclusiveContent: 'Exclusive content',
    popularTopics: 'Popular Topics',
    topicUsucapiao: 'Adverse Possession',
    topicPosse: 'Possession',
    topicPropriedade: 'Property',
    topicPena: 'Criminal Penalty',
    topicDolo: 'Intent (Dolo)',
    topicCulpa: 'Negligence',
    topicObrigacoes: 'Obligations',
    topicContratos: 'Contracts',
    topicSucessao: 'Succession',
    topicFamilia: 'Family Law',

    // Subscription Page
    subActivatedSuccess: 'Subscription activated successfully!',
    aiAccess: 'Access to specialized AI',
    prioritySupport: 'Priority support',
    earlyAccess: 'Early access to new features',
    professionalAnswers: 'Top-tier professional answers',
    payOnceYear: 'Pay only once a year',
    subCurrentPlan: 'Current Plan',
    subUpgradeFreeHint: 'Upgrade to unlock premium features',
    premiumFeatures: 'Premium Features',
    subChoosePlan: 'Choose Your Plan',
    subAccelerateStudies: 'Accelerate your studies with advanced AI features',
    subSubscribeNow: 'Subscribe Now',
    subPlanActive: 'Active Plan',
    subWhyUpgrade: 'Why upgrade?',
    subBenefit1Title: 'Premium Summaries',
    subBenefit1Desc: 'More detailed content, practical examples and in-depth explanations',
    subBenefit2Title: 'Unlimited Search',
    subBenefit2Desc: 'No query limits. Search as many times as you need',
    subBenefit3Title: 'Bibliography',
    subBenefit3Desc: 'Book recommendations and specialized references',
    subModalTitle: 'Complete Your Premium Subscription',
    subModalItemTitleWeekly: 'Weekly Subscription',
    subModalItemTitleMonthly: 'Monthly Subscription',
    subModalItemTitleAnnual: 'Annual Subscription',

    // Mercado Pago Checkout
    mpPublicKeyMissing: 'Mercado Pago public key not configured',
    mpInitError: 'Error loading payment system. Please reload the page.',
    mpInitErrorToast: 'Error initializing payment',
    mpPaymentApproved: 'Payment approved!',
    mpPaymentPending: 'Payment pending. Awaiting confirmation.',
    mpPaymentNotApproved: 'Payment was not approved. Please try again.',
    mpPaymentError: 'Error processing payment',
    mpMustBeLoggedIn: 'You need to be logged in',
    mpPixGenerated: 'PIX generated successfully!',
    mpQrNotGenerated: 'QR Code was not generated. Please try again.',
    mpPixError: 'Error generating PIX',
    mpBoletoGenerated: 'Bank slip generated successfully!',
    mpBoletoNotGenerated: 'Bank slip was not generated. Please try again.',
    mpBoletoError: 'Error generating bank slip',
    mpNotConfiguredTitle: 'Payment System Not Configured',
    mpNotConfiguredDesc: 'The Mercado Pago public key was not found.',
    mpNotConfiguredEnvHint: 'Configure REACT_APP_MERCADO_PAGO_PUBLIC_KEY in the .env file',
    mpChooseMethodTitle: 'Choose Your Payment Method',
    mpSelectHowToPay: 'Select how you want to pay:',
    mpAutoRenewal: 'Automatic renewal',
    mpImmediateApproval: 'Immediate approval',
    mpOneTimeMonthlyPayment: 'One-time monthly payment',
    mpOneTimeWeeklyPayment: 'One-time weekly payment',
    mpOneTimeAnnualPayment: 'One-time annual payment',
    mpInstantPayment: 'Instant payment',
    mpDueIn3Days: 'Due in 3 days',
    mpPaymentSystemErrorTitle: 'Payment System Error',
    mpReloadPage: 'Reload Page',
    mpLoadingPaymentSystem: 'Loading payment system...',
    mpPleaseWait: 'Please wait',
    mpCardProcessError: 'Error processing card. Please try again.',
    mpGeneratingPix: 'Generating PIX...',
    mpGeneratePix: 'Generate PIX',
    mpPixSuccessTitle: 'PIX Generated Successfully!',
    mpPixCodeLabel: 'PIX Code (Copy and Paste):',
    mpCodeCopied: 'Code copied!',
    mpCopy: 'Copy',
    mpPixImportantTitle: 'Important About PIX Payment',
    mpPixOnceNotAutoRenewed: 'The PIX payment is one-time and is NOT automatically renewed. You will need to pay again when the period expires to keep your subscription active.',
    mpPixAutoRenewalPrefix: 'For automatic renewal, choose',
    mpHowToPayTitle: 'How to pay:',
    mpPixStep1: 'Open your bank app',
    mpPixStep2: 'Choose to pay with PIX',
    mpPixStep3: 'Scan the QR Code or paste the code',
    mpPixStep4Prefix: 'Confirm the payment of',
    mpPixProcessedInstantly: 'The payment is processed instantly after confirmation',
    mpAlreadyPaid: 'I Already Paid',
    mpBoletoWillBeGenerated: 'The bank slip will be generated and you can pay it at any bank.',
    mpGeneratingBoleto: 'Generating Bank Slip...',
    mpGenerateBoleto: 'Generate Bank Slip',
    mpBoletoSuccessTitle: 'Bank Slip Generated Successfully!',
    mpBoletoLineLabel: 'Bank Slip Barcode Number:',
    mpLineCopied: 'Barcode number copied!',
    mpValueLabel: 'Amount:',
    mpDueDateLabel: 'Due Date:',
    mpBeneficiaryLabel: 'Beneficiary:',
    mpViewPrintBoleto: 'View/Print Bank Slip',
    mpBoletoStep1: 'Copy the barcode number above',
    mpBoletoStep2: 'Access your bank app or website',
    mpBoletoStep3: 'Choose "Pay Bank Slip"',
    mpBoletoStep4: 'Paste the barcode number',
    mpBoletoStep5: 'Confirm payment by the due date',
    mpBoletoConfirmTime: 'The bank slip takes 1 to 3 business days to be confirmed after payment',
    mpProcessingPayment: 'Processing payment...',

    // Auth Callback / Mind Map / Quiz Analytics
    authProcessing: 'Processing authentication...',
    mmPdfSaved: 'PDF saved successfully!',
    mmPdfError: 'Error generating PDF',
    mmLinkCopied: 'Link copied!',
    mmLinkCreatedCopied: 'Link created and copied!',
    mmShareError: 'Error generating share link',
    mmLightMode: 'Light',
    mmPrintMode: 'Print',
    mmCopied: 'Copied!',
    mmCopyLink: 'Copy',
    mmShare: 'Share',
    mmClose: 'Close',
    qaTrend: 'Trend',
    qaImproving: 'Improving',
    qaAttention: 'Attention',
    qaStable: 'Stable',
    qaScoreEvolution: 'Score Evolution',
    qaAccuracy: 'Accuracy',
    qaPerformanceByArea: 'Performance by Area',

    // Shared Map / Shared Slides
    smMapNotFound: 'Map not found or link expired.',
    smMapNotFoundFallback: 'Map not found',
    smLinkIncorrectHint: 'The link may be incorrect or the map has been removed.',
    smBackHome: 'Back to Home',
    ssPresentationNotFound: 'Presentation not found or link expired.',
    ssInvalidLink: 'Invalid link',
    ssSharedPresentation: 'Shared Presentation',
    ssSlideLabel: 'Slide',
    ssPrevious: 'Previous',
    ssNext: 'Next',
    ssFooterGenerated: 'Generated by Law Study A.I — Use the keyboard arrows to navigate',

    // Ebook Detail Page
    ebdNotFound: 'E-book not found',
    ebdLoading: 'Loading e-book...',
    ebdFreeBadge: 'FREE',
    ebdLoginToBuy: 'Log in to purchase e-books',
    ebdAddedToLibrary: 'E-book added to your library!',
    ebdPurchasedForPrefix: 'E-book purchased for',
    mocked: 'mocked',
    ebdPurchaseError: 'Error purchasing e-book',
    ebdActiveSubscription: 'Active subscription — full access',
    ebdReadEbook: 'Read E-book',
    ebdViewAllEbooks: 'View All E-books',
    ebdLoginToBuySimple: 'Log in to purchase',
    ebdGetFree: 'Get for Free',
    ebdBuyNow: 'Buy Now',
    ebdLoginLink: 'Log in',
    ebdToBuyThisEbook: 'to buy this e-book',
    ebdPurchaseSuccess: 'Purchase completed successfully!',
    ebdWhatYouWillLearn: "What you'll learn:",
    ebdFeature1: 'Specialized and educational content',
    ebdFeature2: 'Practical examples and real cases',
    ebdFeature3: 'Updated legislation',
    ebdFeature4: 'Lifetime access after purchase',

    // Atualizações Jurídicas (list + detail)
    audNotFound: 'Update not found',
    audLoginToFavorite: 'Log in to favorite',
    audFavoriteError: 'Error favoriting',
    audLinkCopied: 'Link copied!',
    audTypeNoticia: 'News',
    audTypeLegislacao: 'Legislation',
    audTypeJurisprudencia: 'Case Law',
    audTypeArtigo: 'Article',
    audBrazilianLaw: 'Brazilian Law',
    audInternationalLaw: 'International Law',
    audSourceLabel: 'Source:',
    audViewOriginalSource: 'View original source',
    audFavorited: 'Favorited',
    audFavoriteAction: 'Favorite',
    audBackToUpdates: 'Back to updates',
    ajErrorLoading: 'Error loading updates',
    ajLoginToFavorite: 'Log in to favorite updates',
    ajAddedToFavorites: 'Added to favorites',
    ajRemovedFromFavorites: 'Removed from favorites',
    ajNewUpdatesAdded: 'new updates added!',
    ajNoNewUpdates: 'No new updates found',
    ajSyncError: 'Error syncing news',
    ajLoadingUpdates: 'Loading updates...',
    ajPageTitle: 'Legal Updates',
    ajPageSubtitle: 'Brazilian and International legal content, always up to date',
    ajSearchPlaceholder: 'Search updates...',
    ajHideFilters: 'Hide Filters',
    ajShowFilters: 'Show Filters',
    ajSearching: 'Searching...',
    ajSearchNews: 'Search News',
    ajCategory: 'Category',
    ajAll: 'All',
    ajType: 'Type',
    ajArea: 'Area',
    ajAreaCivil: 'Civil Law',
    ajAreaPenal: 'Criminal Law',
    ajAreaLabor: 'Labor Law',
    ajAreaConstitutional: 'Constitutional Law',
    ajAreaAdministrative: 'Administrative Law',
    ajAreaTax: 'Tax Law',
    ajAreaInternational: 'International Law',
    ajClearFilters: 'Clear Filters',
    ajUpdatesFound: 'updates found',
    ajBrazilShort: 'Brazilian',
    ajInternationalShort: 'International',
    ajReadOriginalSource: 'Read original source',
    ajNoUpdatesFound: 'No updates found',
    ajTryAdjustingFilters: 'Try adjusting the filters or searching for other terms',

    // Quiz Page
    qzLoginRequired: 'Please log in to access the quizzes',
    qzFillAllFields: 'Please fill in all fields',
    qzGeneratedSuccess: 'Quiz generated successfully!',
    qzGenerateError: 'Error generating quiz',
    qzSelectAnswer: 'Select an answer',
    qzCompletedToastPrefix: 'Quiz completed! You got',
    qzOf: 'of',
    qzQuestionsWord: 'questions',
    qzSubmitError: 'Error submitting quiz',
    qzHistoryError: 'Error loading history',
    qzBack: 'Back',
    qzViewHistory: 'View History',
    qzTitle: 'Educational Quiz',
    qzSubtitle: 'Test your knowledge and learn with detailed explanations',
    qzAreaLabel: 'Area of Law',
    qzSelectArea: 'Select the area',
    qzQuestionTypeLabel: 'Question Type',
    qzSelectType: 'Select the type',
    qzMultipleChoice: 'Multiple Choice',
    qzTrueFalse: 'True or False',
    qzMixed: 'Mixed (Both)',
    qzDifficultyLabel: 'Difficulty Level',
    qzSelectLevel: 'Select the level',
    qzBasic: 'Basic',
    qzIntermediate: 'Intermediate',
    qzAdvanced: 'Advanced',
    qzNumQuestionsLabel: 'Number of Questions',
    qzGenerating: 'Generating Quiz...',
    qzGenerateBtn: 'Generate Quiz',
    qzQuestionWord: 'Question',
    qzPreviousBtn: 'Previous',
    qzFinishQuiz: 'Finish Quiz',
    qzNextBtn: 'Next',
    qzCompletedTitle: 'Quiz Completed!',
    qzYouGot: 'You got',
    qzExcellent: 'Excellent!',
    qzGoodJob: 'Good job!',
    qzKeepStudying: 'Keep studying!',
    qzYourAnswer: 'Your answer:',
    qzCorrectAnswer: 'Correct answer:',
    qzExplanationLabel: 'Explanation:',
    qzNewQuiz: 'New Quiz',
    qzGeneralStats: 'General Statistics',
    qzStatQuizzes: 'Quizzes',
    qzStatCorrect: 'Correct',
    qzStatQuestions: 'Questions',
    qzStatPerformance: 'Performance',
    qzHistoryTitle: 'Quiz History',
    qzNoQuizzesYet: 'No quizzes taken yet',
    qzFirstQuiz: 'Take First Quiz',
    qzVF: 'T/F',
    qzRestrictedAccess: 'Restricted Access',
    qzLoginToAccess: 'You need to log in to access the educational quizzes',
    qzDoLogin: 'Log In',
    qzAreaBusiness: 'Business Law',
    qzAreaCivilProcedure: 'Civil Procedure Law',
    qzAreaCriminalProcedure: 'Criminal Procedure Law',
    qzAreaConsumer: 'Consumer Law',
    
    // Payment
    paymentMethods: 'Payment Methods',
    pix: 'PIX',
    creditCard: 'Credit Card',
    boleto: 'Bank Slip',
    
    // Quiz
    quizTitle: 'Educational Quiz',
    selectArea: 'Select Area',
    selectType: 'Question Type',
    selectLevel: 'Difficulty Level',
    numberOfQuestions: 'Number of Questions',
    startQuiz: 'Start Quiz',
    
    // Mind Maps
    mindMapsTitle: 'Legal Mind Maps',
    mindMapsDescription: 'Visual summaries of main Law topics',
    
    // Subscription
    subscriptionPlans: 'Subscription Plans',
    weekly: 'Weekly',
    monthly: 'Monthly',
    annual: 'Annual',
    subscribe: 'Subscribe',
    
    // Landing Page
    landingTitle: 'Simplify Your Legal Studies',
    landingSubtitle: 'AI Platform for Law Students',
    getStarted: 'Get Started',
    features: 'Features',
    pricing: 'Pricing',
    
    // More sections
    premiumAccess: 'Premium Access',
    unlimitedSearch: 'Unlimited searches',
    detailedSummaries: 'Detailed summaries',
    practicalExamples: 'Practical examples',
    specializedBibliography: 'Specialized bibliography',
    perWeek: 'per week',
    perMonth: 'per month',
    perYear: 'per year',
    chooseArea: 'Choose Area',
    difficulty: 'Difficulty',
    basic: 'Basic',
    intermediate: 'Intermediate',
    advanced: 'Advanced',
    correct: 'Correct',
    incorrect: 'Incorrect',
    score: 'Score',
    total: 'Total',
    explanation: 'Explanation',
    continue: 'Continue',
    finish: 'Finish',
    results: 'Results',
    yourScore: 'Your Score',
    correctAnswers: 'Correct Answers',
    viewDetails: 'View Details',
    tryAgain: 'Try Again',
    backToDashboard: 'Back to Dashboard',
    purchase: 'Purchase',
    price: 'Price',
    lifetimeAccess: 'Lifetime access',
    paymentMethod: 'Payment Method',
    processing: 'Processing...',
    purchased: 'Purchased',
    alreadyPurchased: 'Already Purchased',
    scanQRCode: 'Scan QR Code',
    copyCode: 'Copy Code',
    alreadyPaid: 'Already Paid',
    generating: 'Generating...',
    viewLibrary: 'View Library',
    noItems: 'No items',
    history: 'History',
    statistics: 'Statistics',
    attempts: 'Attempts',
    averageScore: 'Average Score',
    byArea: 'By Area',
    backToHome: 'Back to home',
    orSeparator: 'or',
    legalUpdates: 'Legal Updates',
    choosePlan: 'Choose Plan',
    dashboard: 'Dashboard',

    // Create Page
    criarTitle: 'Create',
    criarPecasProcessuais: 'Legal Documents',
    criarApresentacoes: 'Presentations',
    criarNovoDocumento: 'New Document',
    criarNenhumDocumento: 'No documents yet',
    criarGerarPeca: 'Generate Legal Document',
    criarGerarPecaDesc: 'Fill in the details and AI will create the complete document with real legal reasoning',
    criarGerarApresentacao: 'Generate Presentation',
    criarGerarApresentacaoDesc: 'Enter the legal topic and receive professional slides ready to present',
    criarTipoPeca: 'Document Type',
    criarSelecioneTipo: 'Select type...',
    criarNomeAutor: 'Plaintiff/Petitioner Name',
    criarPlaceholderAutor: 'E.g.: John Smith',
    criarDadosAutor: 'Plaintiff Details',
    criarPlaceholderDadosAutor: 'ID, address, occupation...',
    criarNomeReu: 'Defendant/Respondent Name',
    criarPlaceholderReu: 'E.g.: XYZ Company Ltd.',
    criarDadosReu: 'Defendant Details',
    criarPlaceholderDadosReu: 'Tax ID, address...',
    criarAutorNomeCompleto: 'Full name',
    criarAutorDocumento: 'ID / Tax number',
    criarPlaceholderAutorDoc: 'E.g.: 123.456.789-00',
    criarAutorProfissao: 'Occupation',
    criarPlaceholderAutorProf: 'E.g.: Merchant',
    criarAutorEndereco: 'Address',
    criarPlaceholderAutorEnd: 'Street, number, district, city/state',
    criarReuNomeCompleto: 'Full name / Company name',
    criarReuDocumento: 'ID / Tax number',
    criarPlaceholderReuDoc: 'E.g.: 12.345.678/0001-99',
    criarReuEndereco: 'Address',
    criarPlaceholderReuEnd: 'Street, number, district, city/state',
    criarForo: 'Court / Venue',
    criarPlaceholderForo: 'E.g.: 3rd Civil Court of São Paulo/SP',
    criarSituacao: 'Situation / Facts',
    criarPlaceholderSituacao: 'Describe in detail the facts, the legal issue and what you want to achieve...',
    criarGerandoPeca: 'Generating document...',
    criarTemaApresentacao: 'Presentation Topic',
    criarPlaceholderTema: 'E.g.: Principles of Brazilian Criminal Law',
    criarNumSlides: 'Number of Slides',
    criarDetalhesAdicionais: 'Additional Details',
    criarPlaceholderDetalhes: 'Focus on case law? Academic level? Target audience?',
    criarGerandoApresentacao: 'Generating presentation...',
    criarAnterior: 'Previous',
    criarProximo: 'Next',
    criarAutorLabel: 'Plaintiff',
    criarReuLabel: 'Defendant',
    criarForoLabel: 'Court',
    criarPreenchaCampos: 'Please fill in all required fields',
    criarInformeTema: 'Please enter the presentation topic',
    criarRecursoExclusivo: 'Feature exclusive to subscribers',
    criarPecaGerada: 'Legal document generated successfully!',
    criarErroPeca: 'Error generating document',
    criarApresentacaoGerada: 'Presentation generated successfully!',
    criarErroSlides: 'Error generating slides',
    criarExportadoComo: 'Exported as',
    criarErroExportar: 'Error exporting document',
    criarErroCarregar: 'Error loading document',
    criarDocExcluido: 'Document deleted',
    criarErroExcluir: 'Error deleting',
    criarPeticaoInicial: 'Initial Petition',
    criarContestacao: 'Defense Response',
    criarApelacao: 'Appeal',
    criarMandadoSeguranca: 'Writ of Mandamus',
    criarHabeasCorpus: 'Habeas Corpus',
    criarRecursoEspecial: 'Special Appeal',
    criarAgravo: 'Interlocutory Appeal',
    criarReconvencao: 'Counterclaim',
    criarEmbargosDeclaracao: 'Clarification Motion',
    criarAcaoIndenizacao: 'Compensation Action',
    criarSlides: 'slides',
    criarSalvarRascunho: 'Save Draft',
    criarRascunhoSalvo: 'Draft saved successfully!',
    criarRascunhoAtualizado: 'Draft updated!',
    criarErroRascunho: 'Error saving draft',
    criarRascunhos: 'Drafts',
    criarRascunhoExcluido: 'Draft deleted',
    criarEditarRascunho: 'Edit draft',
    criarGerarDoRascunho: 'Generate from this Draft',
    criarSalvando: 'Saving...',

    // Mind Maps Custom
    mapasCriar: 'Create Mind Map',
    mapasTema: 'Mind Map Topic',
    mapasPlaceholderTema: 'E.g.: Criminal Law - Crimes against persons',
    mapasProfundidade: 'Depth Level',
    mapasBasico: 'Basic (3 topics)',
    mapasIntermediario: 'Intermediate (5 topics)',
    mapasAvancado: 'Advanced (7 topics)',
    mapasGerar: 'Generate Mind Map',
    mapasGerando: 'Generating mind map...',
    mapasGerado: 'Mind map generated successfully!',
    mapasErro: 'Error generating mind map',
    mapasMeus: 'My Maps',
    mapasExcluido: 'Map deleted',
    mapasNenhum: 'No maps created yet',
    mapasAprendizado: 'Visual Learning',
    mapasTitulo: 'Legal Mind Maps',
    mapasDescricao: 'Visual summaries of key legal topics with practical and easy-to-understand examples',
    mapasComoUsar: 'How to use Mind Maps?',
    mapasTopicsCount: 'topics',
    mapasSubtopicsCount: 'subtopics',
    mapasHowToUse1: 'Click "View" to see the mind map in an interactive tree format',
    mapasHowToUse2: 'Hover over the nodes to see details and examples',
    mapasHowToUse3: 'Use the PDF button to save and print your mind map',
    ebooksLoadError: 'Error loading e-books',
    dashAnalyzeImage: 'Analyze image',
    dashHidePanel: 'Hide panel',
    dashShowPanel: 'Show panel',
    untitledConversation: 'Untitled',
    dashImageSentAlt: 'Image sent',
    mapasFavoriteError: 'Error adding to favorites',
    mapasConfirmDelete: 'Do you want to delete this mind map?',
    ebooksLoading: 'Loading e-books...',
    erpMustPurchaseFirst: 'You need to purchase this e-book first',
    erpLoadContentError: 'Error loading content',
    erpTranslationTimeout: 'Translation timed out. Please try again.',
    erpTranslationServerError: 'Translation server error. Please try again later.',
    erpTranslatePageError: 'Error translating page',
    erpEbookInPortuguese: 'E-book in Portuguese',
    erpTranslatingTo: 'Translating to',
    erpTranslationAppliedPerPage: 'The translation will be applied page by page',
    erpSelectLanguageForTranslation: 'Select the language for translation',
    erpMainLanguages: 'Main Languages',
    erpAsia: 'Asia',
    erpEurope: 'Europe',
    erpAfrica: 'Africa',
    erpAmericasOceania: 'Americas & Oceania',
    erpOtherLanguages: 'Other Languages',
    erpTranslating: 'Translating...',
    erpTranslatingContent: 'Translating content...',
    erpChapter: 'Chapter',
    erpPracticalExamples: 'Practical Examples',
    erpPreviousPage: 'Previous Page',
    erpNextPage: 'Next Page',
    erpNextChapter: 'Next',
    mapasClique: 'Click on topics to expand and see details',
    mapasExemplo: 'Each practical example helps memorization',
    mapasGuia: 'Use as a quick review guide before exams',
    mapasCarregando: 'Loading mind maps...',
    mapasErroCarregar: 'Error loading mind maps',

    // Welcome / Dashboard dynamic
    welcomeTitle: 'How can I help you?',
    welcomeSubtitle: 'Ask a question about any legal topic',
    summarizeLegalText: 'Summarize Legal Text',
    summarizeLegalTextDesc: 'Upload lawsuits, petitions, appeals, or exam questions',
    images: 'Images',
    photos: 'Photos',
    aiAnalysis: 'AI Analysis',
    premiumAnalysisActive: 'Premium Analysis Active',
    eLawyerTitle: 'E-Lawyer - Virtual Attorney',
    eLawyerDesc: 'Consult a virtual attorney specialized in ALL areas of Law',
    areaCivil: 'Civil',
    areaPenal: 'Criminal',
    areaLabor: 'Labor',
    areaConstitutional: 'Constitutional',
    areaAdministrative: 'Administrative',
    areaTax: 'Tax',
    andMore: 'And more!',
    premiumConsultActive: 'Premium Consultation Active - Specialized Answers',
    sessionExpired: 'Session expired. Please log in again.',
    newConvStarted: 'New conversation started',
    confirmDeleteConv: 'Do you really want to delete this conversation?',
    convDeleted: 'Conversation deleted successfully!',
    errorDeleteConv: 'Error deleting conversation',
    confirmClearAll: 'Do you really want to clear all conversation history? Favorite conversations will be kept.',
    historyCleared: 'History cleared successfully!',
    errorClearHistory: 'Error clearing history',
    addToFavorites: 'Add to favorites',
    removeFromFavorites: 'Remove from favorites',
    addedToFavorites: 'Conversation added to favorites',
    removedFromFavorites: 'Conversation removed from favorites',
    errorToggleFavorite: 'Error favoriting conversation',
    noConversationsToClear: 'No conversations to clear',
    showFavoritesOnly: 'Show favorites only',
    showAllConversations: 'Show all conversations',
    noFavoriteConversations: 'No favorite conversations yet',
    noConversationsYet: 'No conversations yet',
    noSearchResults: 'No results found',
    unsupportedFormat: 'Unsupported format. Use images (JPG, PNG) or PDF',
    fileTooLarge: 'File too large. Maximum 10MB',
    analyzingDoc: 'Analyzing document...',
    premiumAnalysisDone: 'Premium Analysis Complete!',
    docAnalyzed: 'Document Analyzed!',
    errorAnalyzeDoc: 'Error analyzing document. Please try again.',
    errorProcessQuestion: 'Error processing question',
    logoutSuccess: 'Logged out successfully',
    legalAssistant: 'Legal Assistant',
    eLawyerHeaderDesc: 'Specialized legal consultation in all areas of Law',
    askAnythingAboutLaw: 'Ask any question about Law',
    chatExportedPdf: 'Conversation exported as PDF!',
    errorExportChat: 'Error exporting conversation',
    fileSelected: 'File selected',
    addComment: 'Add a comment (optional)',
    sendFileForAnalysis: 'Send file for analysis',
    suggestion1: 'Explain the concept of adverse possession',
    suggestion2: 'Difference between intent and negligence',
    suggestion3: 'How to calculate base sentence?',
    suggestion4: 'What is legal possession?',
    searchConversation: 'Search conversation...',
    errorAnswerRecord: 'Error recording answer',
    filterByArea: 'Filter by area:',
    allAreas2: 'All Areas',
    questionOf: 'Question',
    of: 'of',
    correctAnswer: 'Correct Answer!',
    incorrectAnswer: 'Incorrect Answer',
    completedAllQuestions: 'You completed all questions in this area!',
    nextQuestion: 'Next Question',
    completedAll: 'You completed all questions!',
    loadingQuestions: 'Loading questions...',
    noQuestionsFound: 'No questions found for this area',
    viewAll: 'View All',
    accuracy: 'accuracy',
    loginToAccessQuestions: 'Please log in to access questions',
    errorLoadQuestions: 'Error loading questions',
    docSent: 'Document sent',
    allRightsReserved: '© 2025 Law Study A.I. All rights reserved.',
    availableLanguages: 'Languages: Portuguese, English, Spanish, French',
    
    // Ebook Index
    tableOfContents: 'Table of Contents',
    page: 'Page',
    
    // Presentation Mode
    presentationMode: 'Present',
    exitPresentation: 'Exit',
    pressEscToExit: 'Press ESC to exit',
    
    // Videos
    videosTitle: 'Educational Videos',
    videosSubtitle: 'Generate animated videos about legal topics with audio narration',
    videoPromptLabel: 'Describe the video topic *',
    videoPromptPlaceholder: 'E.g.: Explain the concept of habeas corpus and when it can be used...',
    videoLanguageLabel: 'Video language',
    videoSubtitlesLabel: 'Include subtitles',
    videoDurationLabel: 'Video duration',
    videoGenerate: 'Generate Video',
    videoGenerating: 'Generating...',
    videoHistory: 'History',
    videoNoHistory: 'No videos generated yet',
    videoStatusQueued: 'Queued',
    videoStatusScript: 'Generating script...',
    videoStatusAudio: 'Generating narration...',
    videoStatusVideo: 'Generating animation...',
    videoSceneLabel: 'Scene',
    videoSceneOfLabel: 'of',
    videoStatusMerging: 'Merging final video...',
    videoStatusCompleted: 'Completed',
    videoStatusError: 'Error',
    videoSeconds: 'seconds',
    videoDeleteConfirm: 'Do you really want to delete this video?',
    videoDeleted: 'Video deleted',
    videoRetry: 'Try Again',
    videoRetryHint: 'Prompt copied. Click Generate to try again.',
    videoNarration: 'Narration Script',
    videoSubtitlesText: 'Subtitles',
    videoSubtitlesToggle: 'Subtitles',
    videoGenerateSuccess: 'Video started! Track progress below.',
    videoGenerateError: 'Error generating video',
    navVideos: 'Videos',
    videoShare: 'Share',
    videoCopyLink: 'Copy Link',
    videoLinkCopied: 'Link Copied!',
    videoDownload: 'Download',
    videoMinutes: 'minutes',
    galleryTitle: 'Video Gallery',
    gallerySubtitle: 'Explore educational videos shared by the community',
    gallerySearch: 'Search by topic...',
    galleryEmpty: 'No videos in the gallery yet',
    galleryEmptyDesc: 'Be the first to share an educational video!',
    galleryCreateVideo: 'Create Video',
    navGallery: 'Gallery'
  },

  es: {
    // General
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    save: 'Guardar',
    back: 'Volver',
    next: 'Siguiente',
    
    // Auth
    login: 'Iniciar sesión',
    register: 'Registrarse',
    email: 'Correo electrónico',
    password: 'Contraseña',
    name: 'Nombre',
    alreadyHaveAccount: '¿Ya tienes una cuenta?',
    dontHaveAccount: '¿No tienes una cuenta?',
    loginWithGoogle: 'Iniciar sesión con Google',
    loginGoogleOnly: 'Esta cuenta usa inicio de sesión con Google. Por favor, inicie sesión con Google.',
    loginError: 'Email o contraseña inválidos',
    loginSuccess: '¡Inicio de sesión exitoso!',
    registerSuccess: '¡Cuenta creada con éxito!',
    registerError: 'Error al crear la cuenta',
    registerEmailExists: 'Este email ya está registrado',
    welcome: 'Bienvenido',
    askQuestion: 'Haz una pregunta sobre Derecho...',
    send: 'Enviar',
    clearHistory: 'Limpiar Historial',
    clearConversation: 'Limpiar Conversación',
    newConversation: 'Nueva Conversación',
    conversationHistory: 'Historial de Conversaciones',
    logout: 'Salir',
    language: 'Idioma',
    aiAssistant: 'Asistente de IA Legal',
    typeMessage: 'Escribe tu mensaje...',
    
    // Navigation
    questions: 'Preguntas',
    quiz: 'Quiz Educativo',
    mindMaps: 'Mapas Mentales',
    ebooks: 'E-books',
    myLibrary: '',
    subscription: 'Suscripción',
    
    // E-books
    ebooksTitle: 'Biblioteca de E-books Jurídicos',
    ebooksDescription: 'E-books especializados por solo R$ 25,00 cada uno',
    subscriberAccess: 'Acceso ilimitado a todos los e-books',
    subscriberAccessDesc: 'Tu suscripción incluye acceso gratuito a toda la biblioteca de e-books',
    ebooksSubtitle: 'Materiales educativos completos para tus estudios',
    allAreas: 'Todos',
    free: 'Gratis',
    buy: 'Comprar',
    read: 'Leer',
    noEbooksFound: 'No se encontraron e-books',
    searchPlaceholder: 'Buscar por título, área o descripción...',
    
    // Landing Page
    heroTitle: 'Estudia Derecho con Inteligencia Artificial',
    heroDescription: 'Resuelve tus dudas jurídicas con nuestra IA especializada en Derecho brasileño',
    howItWorks: 'Cómo Funciona',
    featuresTitle: 'Características Exclusivas',
    aiAssistantFeature: 'Asistente IA Legal',
    aiAssistantDesc: 'Chat inteligente para resolver dudas legales',
    ebooksFeature: 'E-books Especializados',
    ebooksFeatureDesc: 'Biblioteca completa de materiales educativos',
    quizFeature: 'Quiz Interactivo',
    quizFeatureDesc: 'Prueba tus conocimientos con preguntas',
    mindMapsFeature: 'Mapas Mentales',
    mindMapsFeatureDesc: 'Visualiza conceptos claramente',
    pricingTitle: 'Elige tu Plan',
    pricingSubtitle: 'Planes flexibles para tu estudio',
    mostPopular: 'Más Popular',
    objectiveExamples: 'Ejemplos objetivos',
    basicSupport: 'Soporte básico',
    premiumSummaries: 'Resúmenes premium',
    bookRecommendations: 'Recomendaciones de libros',
    advancedExamples: 'Ejemplos avanzados',
    everythingInMonthly: 'Todo del Mensual',
    save79: 'Ahorra 79%',
    exclusiveContent: 'Contenido exclusivo',
    popularTopics: 'Tópicos Populares',
    topicUsucapiao: 'Usucapión',
    topicPosse: 'Posesión',
    topicPropriedade: 'Propiedad',
    topicPena: 'Pena',
    topicDolo: 'Dolo',
    topicCulpa: 'Culpa',
    topicObrigacoes: 'Obligaciones',
    topicContratos: 'Contratos',
    topicSucessao: 'Sucesión',
    topicFamilia: 'Familia',

    // Subscription Page
    subActivatedSuccess: '¡Suscripción activada con éxito!',
    aiAccess: 'Acceso a IA especializada',
    prioritySupport: 'Soporte prioritario',
    earlyAccess: 'Acceso anticipado a nuevas funciones',
    professionalAnswers: 'Respuestas profesionales de primer nivel',
    payOnceYear: 'Solo pagas una vez al año',
    subCurrentPlan: 'Plan Actual',
    subUpgradeFreeHint: 'Mejora tu plan para desbloquear funciones premium',
    premiumFeatures: 'Funciones Premium',
    subChoosePlan: 'Elige tu Plan',
    subAccelerateStudies: 'Acelera tus estudios con funciones avanzadas de IA',
    subSubscribeNow: 'Suscribirse Ahora',
    subPlanActive: 'Plan Activo',
    subWhyUpgrade: '¿Por qué mejorar tu plan?',
    subBenefit1Title: 'Resúmenes Premium',
    subBenefit1Desc: 'Contenido más detallado, ejemplos prácticos y explicaciones profundas',
    subBenefit2Title: 'Búsqueda Ilimitada',
    subBenefit2Desc: 'Sin límites de consultas. Busca cuantas veces necesites',
    subBenefit3Title: 'Bibliografía',
    subBenefit3Desc: 'Recomendaciones de libros y referencias especializadas',
    subModalTitle: 'Finalizar Suscripción Premium',
    subModalItemTitleWeekly: 'Suscripción Semanal',
    subModalItemTitleMonthly: 'Suscripción Mensual',
    subModalItemTitleAnnual: 'Suscripción Anual',

    // Mercado Pago Checkout
    mpPublicKeyMissing: 'Clave pública de Mercado Pago no configurada',
    mpInitError: 'Error al cargar el sistema de pago. Intenta recargar la página.',
    mpInitErrorToast: 'Error al inicializar el pago',
    mpPaymentApproved: '¡Pago aprobado!',
    mpPaymentPending: 'Pago pendiente. Esperando confirmación.',
    mpPaymentNotApproved: 'El pago no fue aprobado. Intenta nuevamente.',
    mpPaymentError: 'Error al procesar el pago',
    mpMustBeLoggedIn: 'Debes iniciar sesión',
    mpPixGenerated: '¡PIX generado con éxito!',
    mpQrNotGenerated: 'El código QR no se generó. Intenta nuevamente.',
    mpPixError: 'Error al generar PIX',
    mpBoletoGenerated: '¡Boleto generado con éxito!',
    mpBoletoNotGenerated: 'El boleto no se generó. Intenta nuevamente.',
    mpBoletoError: 'Error al generar el boleto',
    mpNotConfiguredTitle: 'Sistema de Pago No Configurado',
    mpNotConfiguredDesc: 'No se encontró la clave pública de Mercado Pago.',
    mpNotConfiguredEnvHint: 'Configura REACT_APP_MERCADO_PAGO_PUBLIC_KEY en el archivo .env',
    mpChooseMethodTitle: 'Elige el Método de Pago',
    mpSelectHowToPay: 'Selecciona cómo deseas pagar:',
    mpAutoRenewal: 'Renovación automática',
    mpImmediateApproval: 'Aprobación inmediata',
    mpOneTimeMonthlyPayment: 'Pago único mensual',
    mpOneTimeWeeklyPayment: 'Pago único semanal',
    mpOneTimeAnnualPayment: 'Pago único anual',
    mpInstantPayment: 'Pago instantáneo',
    mpDueIn3Days: 'Vence en 3 días',
    mpPaymentSystemErrorTitle: 'Error en el Sistema de Pago',
    mpReloadPage: 'Recargar Página',
    mpLoadingPaymentSystem: 'Cargando sistema de pago...',
    mpPleaseWait: 'Por favor, espera',
    mpCardProcessError: 'Error al procesar la tarjeta. Intenta nuevamente.',
    mpGeneratingPix: 'Generando PIX...',
    mpGeneratePix: 'Generar PIX',
    mpPixSuccessTitle: '¡PIX Generado con Éxito!',
    mpPixCodeLabel: 'Código PIX (Copiar y Pegar):',
    mpCodeCopied: '¡Código copiado!',
    mpCopy: 'Copiar',
    mpPixImportantTitle: 'Importante sobre el Pago vía PIX',
    mpPixOnceNotAutoRenewed: 'El pago vía PIX es único y NO se renueva automáticamente. Deberás pagar nuevamente cuando el período expire para mantener tu suscripción activa.',
    mpPixAutoRenewalPrefix: 'Para renovación automática, elige',
    mpHowToPayTitle: 'Cómo pagar:',
    mpPixStep1: 'Abre la app de tu banco',
    mpPixStep2: 'Elige pagar con PIX',
    mpPixStep3: 'Escanea el código QR o pega el código',
    mpPixStep4Prefix: 'Confirma el pago de',
    mpPixProcessedInstantly: 'El pago se procesa instantáneamente tras la confirmación',
    mpAlreadyPaid: 'Ya Pagué',
    mpBoletoWillBeGenerated: 'El boleto se generará y podrás pagarlo en cualquier banco.',
    mpGeneratingBoleto: 'Generando Boleto...',
    mpGenerateBoleto: 'Generar Boleto',
    mpBoletoSuccessTitle: '¡Boleto Generado con Éxito!',
    mpBoletoLineLabel: 'Línea Digitable del Boleto:',
    mpLineCopied: '¡Línea digitable copiada!',
    mpValueLabel: 'Valor:',
    mpDueDateLabel: 'Vencimiento:',
    mpBeneficiaryLabel: 'Beneficiario:',
    mpViewPrintBoleto: 'Ver/Imprimir Boleto',
    mpBoletoStep1: 'Copia la línea digitable de arriba',
    mpBoletoStep2: 'Accede a la app o sitio web de tu banco',
    mpBoletoStep3: 'Elige "Pagar Boleto"',
    mpBoletoStep4: 'Pega la línea digitable',
    mpBoletoStep5: 'Confirma el pago antes de la fecha de vencimiento',
    mpBoletoConfirmTime: 'El boleto tarda de 1 a 3 días hábiles en confirmarse tras el pago',
    mpProcessingPayment: 'Procesando pago...',

    // Auth Callback / Mind Map / Quiz Analytics
    authProcessing: 'Procesando autenticación...',
    mmPdfSaved: '¡PDF guardado con éxito!',
    mmPdfError: 'Error al generar PDF',
    mmLinkCopied: '¡Enlace copiado!',
    mmLinkCreatedCopied: '¡Enlace creado y copiado!',
    mmShareError: 'Error al generar enlace para compartir',
    mmLightMode: 'Claro',
    mmPrintMode: 'Impresión',
    mmCopied: '¡Copiado!',
    mmCopyLink: 'Copiar',
    mmShare: 'Compartir',
    mmClose: 'Cerrar',
    qaTrend: 'Tendencia',
    qaImproving: 'Mejorando',
    qaAttention: 'Atención',
    qaStable: 'Estable',
    qaScoreEvolution: 'Evolución de las Notas',
    qaAccuracy: 'Acierto',
    qaPerformanceByArea: 'Rendimiento por Área',

    // Shared Map / Shared Slides
    smMapNotFound: 'Mapa no encontrado o enlace expirado.',
    smMapNotFoundFallback: 'Mapa no encontrado',
    smLinkIncorrectHint: 'El enlace puede ser incorrecto o el mapa fue eliminado.',
    smBackHome: 'Volver al Inicio',
    ssPresentationNotFound: 'Presentación no encontrada o enlace expirado.',
    ssInvalidLink: 'Enlace inválido',
    ssSharedPresentation: 'Presentación Compartida',
    ssSlideLabel: 'Diapositiva',
    ssPrevious: 'Anterior',
    ssNext: 'Siguiente',
    ssFooterGenerated: 'Generado por Law Study A.I — Usa las flechas del teclado para navegar',

    // Ebook Detail Page
    ebdNotFound: 'E-book no encontrado',
    ebdLoading: 'Cargando e-book...',
    ebdFreeBadge: 'GRATIS',
    ebdLoginToBuy: 'Inicia sesión para comprar e-books',
    ebdAddedToLibrary: '¡E-book añadido a tu biblioteca!',
    ebdPurchasedForPrefix: 'E-book comprado por',
    mocked: 'simulado',
    ebdPurchaseError: 'Error al comprar el e-book',
    ebdActiveSubscription: 'Suscripción activa — acceso completo',
    ebdReadEbook: 'Leer E-book',
    ebdViewAllEbooks: 'Ver Todos los E-books',
    ebdLoginToBuySimple: 'Inicia sesión para comprar',
    ebdGetFree: 'Obtener Gratis',
    ebdBuyNow: 'Comprar Ahora',
    ebdLoginLink: 'Inicia sesión',
    ebdToBuyThisEbook: 'para comprar este e-book',
    ebdPurchaseSuccess: '¡Compra realizada con éxito!',
    ebdWhatYouWillLearn: 'Lo que aprenderás:',
    ebdFeature1: 'Contenido especializado y didáctico',
    ebdFeature2: 'Ejemplos prácticos y casos reales',
    ebdFeature3: 'Legislación actualizada',
    ebdFeature4: 'Acceso vitalicio tras la compra',

    // Atualizações Jurídicas (list + detail)
    audNotFound: 'Actualización no encontrada',
    audLoginToFavorite: 'Inicia sesión para marcar como favorito',
    audFavoriteError: 'Error al marcar como favorito',
    audLinkCopied: '¡Enlace copiado!',
    audTypeNoticia: 'Noticia',
    audTypeLegislacao: 'Legislación',
    audTypeJurisprudencia: 'Jurisprudencia',
    audTypeArtigo: 'Artículo',
    audBrazilianLaw: 'Derecho Brasileño',
    audInternationalLaw: 'Derecho Internacional',
    audSourceLabel: 'Fuente:',
    audViewOriginalSource: 'Ver fuente original',
    audFavorited: 'Favorito',
    audFavoriteAction: 'Marcar como Favorito',
    audBackToUpdates: 'Volver a actualizaciones',
    ajErrorLoading: 'Error al cargar actualizaciones',
    ajLoginToFavorite: 'Inicia sesión para marcar actualizaciones como favoritas',
    ajAddedToFavorites: 'Añadido a favoritos',
    ajRemovedFromFavorites: 'Eliminado de favoritos',
    ajNewUpdatesAdded: '¡nuevas actualizaciones añadidas!',
    ajNoNewUpdates: 'No se encontraron actualizaciones nuevas',
    ajSyncError: 'Error al sincronizar noticias',
    ajLoadingUpdates: 'Cargando actualizaciones...',
    ajPageTitle: 'Actualizaciones Jurídicas',
    ajPageSubtitle: 'Contenido jurídico de Derecho Brasileño e Internacional siempre actualizado',
    ajSearchPlaceholder: 'Buscar actualizaciones...',
    ajHideFilters: 'Ocultar Filtros',
    ajShowFilters: 'Mostrar Filtros',
    ajSearching: 'Buscando...',
    ajSearchNews: 'Buscar Noticias',
    ajCategory: 'Categoría',
    ajAll: 'Todas',
    ajType: 'Tipo',
    ajArea: 'Área',
    ajAreaCivil: 'Derecho Civil',
    ajAreaPenal: 'Derecho Penal',
    ajAreaLabor: 'Derecho Laboral',
    ajAreaConstitutional: 'Derecho Constitucional',
    ajAreaAdministrative: 'Derecho Administrativo',
    ajAreaTax: 'Derecho Tributario',
    ajAreaInternational: 'Derecho Internacional',
    ajClearFilters: 'Limpiar Filtros',
    ajUpdatesFound: 'actualizaciones encontradas',
    ajBrazilShort: 'Brasileño',
    ajInternationalShort: 'Internacional',
    ajReadOriginalSource: 'Leer fuente original',
    ajNoUpdatesFound: 'No se encontraron actualizaciones',
    ajTryAdjustingFilters: 'Intenta ajustar los filtros o buscar otros términos',

    // Quiz Page
    qzLoginRequired: 'Por favor, inicia sesión para acceder a los quizzes',
    qzFillAllFields: 'Por favor, completa todos los campos',
    qzGeneratedSuccess: '¡Quiz generado con éxito!',
    qzGenerateError: 'Error al generar el quiz',
    qzSelectAnswer: 'Selecciona una respuesta',
    qzCompletedToastPrefix: '¡Quiz completado! Acertaste',
    qzOf: 'de',
    qzQuestionsWord: 'preguntas',
    qzSubmitError: 'Error al enviar el quiz',
    qzHistoryError: 'Error al cargar el historial',
    qzBack: 'Volver',
    qzViewHistory: 'Ver Historial',
    qzTitle: 'Quiz Educativo',
    qzSubtitle: 'Pon a prueba tus conocimientos y aprende con explicaciones detalladas',
    qzAreaLabel: 'Área del Derecho',
    qzSelectArea: 'Selecciona el área',
    qzQuestionTypeLabel: 'Tipo de Preguntas',
    qzSelectType: 'Selecciona el tipo',
    qzMultipleChoice: 'Opción Múltiple',
    qzTrueFalse: 'Verdadero o Falso',
    qzMixed: 'Mixto (Ambos)',
    qzDifficultyLabel: 'Nivel de Dificultad',
    qzSelectLevel: 'Selecciona el nivel',
    qzBasic: 'Básico',
    qzIntermediate: 'Intermedio',
    qzAdvanced: 'Avanzado',
    qzNumQuestionsLabel: 'Número de Preguntas',
    qzGenerating: 'Generando Quiz...',
    qzGenerateBtn: 'Generar Quiz',
    qzQuestionWord: 'Pregunta',
    qzPreviousBtn: 'Anterior',
    qzFinishQuiz: 'Finalizar Quiz',
    qzNextBtn: 'Siguiente',
    qzCompletedTitle: '¡Quiz Completado!',
    qzYouGot: 'Acertaste',
    qzExcellent: '¡Excelente!',
    qzGoodJob: '¡Buen trabajo!',
    qzKeepStudying: '¡Sigue estudiando!',
    qzYourAnswer: 'Tu respuesta:',
    qzCorrectAnswer: 'Respuesta correcta:',
    qzExplanationLabel: 'Explicación:',
    qzNewQuiz: 'Nuevo Quiz',
    qzGeneralStats: 'Estadísticas Generales',
    qzStatQuizzes: 'Quizzes',
    qzStatCorrect: 'Aciertos',
    qzStatQuestions: 'Preguntas',
    qzStatPerformance: 'Rendimiento',
    qzHistoryTitle: 'Historial de Quizzes',
    qzNoQuizzesYet: 'Aún no se ha realizado ningún quiz',
    qzFirstQuiz: 'Hacer Primer Quiz',
    qzVF: 'V/F',
    qzRestrictedAccess: 'Acceso Restringido',
    qzLoginToAccess: 'Necesitas iniciar sesión para acceder a los quizzes educativos',
    qzDoLogin: 'Iniciar Sesión',
    qzAreaBusiness: 'Derecho Empresarial',
    qzAreaCivilProcedure: 'Derecho Procesal Civil',
    qzAreaCriminalProcedure: 'Derecho Procesal Penal',
    qzAreaConsumer: 'Derecho del Consumidor',
    
    // Payment
    paymentMethods: 'Métodos de Pago',
    pix: 'PIX',
    creditCard: 'Tarjeta de Crédito',
    boleto: 'Boleto Bancario',
    
    // Quiz
    quizTitle: 'Quiz Educativo',
    selectArea: 'Seleccionar Área',
    selectType: 'Tipo de Preguntas',
    selectLevel: 'Nivel de Dificultad',
    numberOfQuestions: 'Número de Preguntas',
    startQuiz: 'Iniciar Quiz',
    
    // Mind Maps
    mindMapsTitle: 'Mapas Mentales Jurídicos',
    mindMapsDescription: 'Resúmenes visuales de los principales temas del Derecho',
    
    // Subscription
    subscriptionPlans: 'Planes de Suscripción',
    weekly: 'Semanal',
    monthly: 'Mensual',
    annual: 'Anual',
    subscribe: 'Suscribirse',
    
    // Landing Page
    landingTitle: 'Simplifica tus Estudios Jurídicos',
    landingSubtitle: 'Plataforma de IA para Estudiantes de Derecho',
    getStarted: 'Comenzar Ahora',
    features: 'Características',
    pricing: 'Precios',
    
    // More sections
    premiumAccess: 'Acceso Premium',
    unlimitedSearch: 'Búsquedas ilimitadas',
    detailedSummaries: 'Resúmenes detallados',
    practicalExamples: 'Ejemplos prácticos',
    specializedBibliography: 'Bibliografía especializada',
    perWeek: 'por semana',
    perMonth: 'por mes',
    perYear: 'por año',
    chooseArea: 'Elegir Área',
    difficulty: 'Dificultad',
    basic: 'Básico',
    intermediate: 'Intermedio',
    advanced: 'Avanzado',
    correct: 'Correcto',
    incorrect: 'Incorrecto',
    score: 'Puntuación',
    total: 'Total',
    explanation: 'Explicación',
    continue: 'Continuar',
    finish: 'Finalizar',
    results: 'Resultados',
    yourScore: 'Tu Puntuación',
    correctAnswers: 'Respuestas Correctas',
    viewDetails: 'Ver Detalles',
    tryAgain: 'Intentar de Nuevo',
    backToDashboard: 'Volver al Panel',
    purchase: 'Comprar',
    price: 'Precio',
    lifetimeAccess: 'Acceso de por vida',
    paymentMethod: 'Método de Pago',
    processing: 'Procesando...',
    purchased: 'Comprado',
    alreadyPurchased: 'Ya Comprado',
    scanQRCode: 'Escanear Código QR',
    copyCode: 'Copiar Código',
    alreadyPaid: 'Ya Pagué',
    generating: 'Generando...',
    viewLibrary: 'Ver Biblioteca',
    noItems: 'Sin elementos',
    history: 'Historial',
    statistics: 'Estadísticas',
    attempts: 'Intentos',
    averageScore: 'Puntuación Promedio',
    byArea: 'Por Área',
    backToHome: 'Volver al inicio',
    orSeparator: 'o',
    legalUpdates: 'Actualizaciones Jurídicas',
    choosePlan: 'Elegir Plan',
    dashboard: 'Panel',

    // Crear Page
    criarTitle: 'Crear',
    criarPecasProcessuais: 'Piezas Procesales',
    criarApresentacoes: 'Presentaciones',
    criarNovoDocumento: 'Nuevo Documento',
    criarNenhumDocumento: 'Ningún documento aún',
    criarGerarPeca: 'Generar Pieza Procesal',
    criarGerarPecaDesc: 'Complete los datos y la IA creará la pieza completa con fundamentación jurídica real',
    criarGerarApresentacao: 'Generar Presentación',
    criarGerarApresentacaoDesc: 'Ingrese el tema jurídico y reciba diapositivas profesionales listas para presentar',
    criarTipoPeca: 'Tipo de Pieza',
    criarSelecioneTipo: 'Seleccione el tipo...',
    criarNomeAutor: 'Nombre del Demandante/Solicitante',
    criarPlaceholderAutor: 'Ej: Juan García',
    criarDadosAutor: 'Datos del Demandante',
    criarPlaceholderDadosAutor: 'DNI, dirección, profesión...',
    criarNomeReu: 'Nombre del Demandado',
    criarPlaceholderReu: 'Ej: Empresa XYZ S.A.',
    criarDadosReu: 'Datos del Demandado',
    criarPlaceholderDadosReu: 'NIF, dirección...',
    criarAutorNomeCompleto: 'Nombre completo',
    criarAutorDocumento: 'DNI / NIF',
    criarPlaceholderAutorDoc: 'Ej: 12345678A',
    criarAutorProfissao: 'Profesión',
    criarPlaceholderAutorProf: 'Ej: Comerciante',
    criarAutorEndereco: 'Dirección',
    criarPlaceholderAutorEnd: 'Calle, número, barrio, ciudad/provincia',
    criarReuNomeCompleto: 'Nombre completo / Razón social',
    criarReuDocumento: 'DNI / NIF',
    criarPlaceholderReuDoc: 'Ej: B12345678',
    criarReuEndereco: 'Dirección',
    criarPlaceholderReuEnd: 'Calle, número, barrio, ciudad/provincia',
    criarForo: 'Juzgado / Tribunal',
    criarPlaceholderForo: 'Ej: 3er Juzgado Civil de São Paulo/SP',
    criarSituacao: 'Situación / Hechos',
    criarPlaceholderSituacao: 'Describa detalladamente los hechos, el problema jurídico y lo que desea lograr...',
    criarGerandoPeca: 'Generando pieza...',
    criarTemaApresentacao: 'Tema de la Presentación',
    criarPlaceholderTema: 'Ej: Principios del Derecho Penal Brasileño',
    criarNumSlides: 'Número de Diapositivas',
    criarDetalhesAdicionais: 'Detalles Adicionales',
    criarPlaceholderDetalhes: '¿Enfoque en jurisprudencia? ¿Nivel académico? ¿Público objetivo?',
    criarGerandoApresentacao: 'Generando presentación...',
    criarAnterior: 'Anterior',
    criarProximo: 'Siguiente',
    criarAutorLabel: 'Demandante',
    criarReuLabel: 'Demandado',
    criarForoLabel: 'Juzgado',
    criarPreenchaCampos: 'Complete todos los campos obligatorios',
    criarInformeTema: 'Ingrese el tema de la presentación',
    criarRecursoExclusivo: 'Recurso exclusivo para suscriptores',
    criarPecaGerada: '¡Pieza procesal generada con éxito!',
    criarErroPeca: 'Error al generar pieza',
    criarApresentacaoGerada: '¡Presentación generada con éxito!',
    criarErroSlides: 'Error al generar diapositivas',
    criarExportadoComo: 'Exportado como',
    criarErroExportar: 'Error al exportar documento',
    criarErroCarregar: 'Error al cargar documento',
    criarDocExcluido: 'Documento eliminado',
    criarErroExcluir: 'Error al eliminar',
    criarPeticaoInicial: 'Petición Inicial',
    criarContestacao: 'Contestación',
    criarApelacao: 'Apelación',
    criarMandadoSeguranca: 'Mandato de Seguridad',
    criarHabeasCorpus: 'Habeas Corpus',
    criarRecursoEspecial: 'Recurso Especial',
    criarAgravo: 'Agravio de Instrumento',
    criarReconvencao: 'Reconvención',
    criarEmbargosDeclaracao: 'Embargos de Declaración',
    criarAcaoIndenizacao: 'Acción de Indemnización',
    criarSlides: 'diapositivas',
    criarSalvarRascunho: 'Guardar Borrador',
    criarRascunhoSalvo: '¡Borrador guardado con éxito!',
    criarRascunhoAtualizado: '¡Borrador actualizado!',
    criarErroRascunho: 'Error al guardar borrador',
    criarRascunhos: 'Borradores',
    criarRascunhoExcluido: 'Borrador eliminado',
    criarEditarRascunho: 'Editar borrador',
    criarGerarDoRascunho: 'Generar desde este Borrador',
    criarSalvando: 'Guardando...',

    // Mapas Mentales Custom
    mapasCriar: 'Crear Mapa Mental',
    mapasTema: 'Tema del Mapa Mental',
    mapasPlaceholderTema: 'Ej: Derecho Penal - Delitos contra las personas',
    mapasProfundidade: 'Nivel de Profundidad',
    mapasBasico: 'Básico (3 temas)',
    mapasIntermediario: 'Intermedio (5 temas)',
    mapasAvancado: 'Avanzado (7 temas)',
    mapasGerar: 'Generar Mapa Mental',
    mapasGerando: 'Generando mapa mental...',
    mapasGerado: '¡Mapa mental generado con éxito!',
    mapasErro: 'Error al generar mapa mental',
    mapasMeus: 'Mis Mapas',
    mapasExcluido: 'Mapa eliminado',
    mapasNenhum: 'Ningún mapa creado aún',
    mapasAprendizado: 'Aprendizaje Visual',
    mapasTitulo: 'Mapas Mentales Jurídicos',
    mapasDescricao: 'Resúmenes visuales de los principales temas del Derecho con ejemplos prácticos',
    mapasComoUsar: '¿Cómo usar los Mapas Mentales?',
    mapasTopicsCount: 'temas',
    mapasSubtopicsCount: 'subtemas',
    mapasHowToUse1: 'Haz clic en "Ver" para ver el mapa mental en formato de árbol interactivo',
    mapasHowToUse2: 'Pasa el mouse sobre los nodos para ver detalles y ejemplos',
    mapasHowToUse3: 'Usa el botón PDF para guardar e imprimir tu mapa mental',
    ebooksLoadError: 'Error al cargar los e-books',
    dashAnalyzeImage: 'Analizar imagen',
    dashHidePanel: 'Ocultar panel',
    dashShowPanel: 'Mostrar panel',
    untitledConversation: 'Sin título',
    dashImageSentAlt: 'Imagen enviada',
    mapasFavoriteError: 'Error al marcar como favorito',
    mapasConfirmDelete: '¿Deseas eliminar este mapa mental?',
    ebooksLoading: 'Cargando e-books...',
    erpMustPurchaseFirst: 'Necesitas comprar este e-book primero',
    erpLoadContentError: 'Error al cargar el contenido',
    erpTranslationTimeout: 'Tiempo de traducción agotado. Inténtalo de nuevo.',
    erpTranslationServerError: 'Error en el servidor de traducción. Inténtalo más tarde.',
    erpTranslatePageError: 'Error al traducir la página',
    erpEbookInPortuguese: 'E-book en Portugués',
    erpTranslatingTo: 'Traduciendo a',
    erpTranslationAppliedPerPage: 'La traducción se aplicará página por página',
    erpSelectLanguageForTranslation: 'Selecciona el idioma para la traducción',
    erpMainLanguages: 'Idiomas Principales',
    erpAsia: 'Asia',
    erpEurope: 'Europa',
    erpAfrica: 'África',
    erpAmericasOceania: 'Américas y Oceanía',
    erpOtherLanguages: 'Otros Idiomas',
    erpTranslating: 'Traduciendo...',
    erpTranslatingContent: 'Traduciendo contenido...',
    erpChapter: 'Capítulo',
    erpPracticalExamples: 'Ejemplos Prácticos',
    erpPreviousPage: 'Página Anterior',
    erpNextPage: 'Página Siguiente',
    erpNextChapter: 'Siguiente',
    mapasClique: 'Haga clic en los temas para expandir y ver detalles',
    mapasExemplo: 'Cada ejemplo práctico facilita la memorización',
    mapasGuia: 'Use como guía rápida de revisión antes de los exámenes',
    mapasCarregando: 'Cargando mapas mentales...',
    mapasErroCarregar: 'Error al cargar mapas mentales',

    // Welcome / Dashboard dynamic
    welcomeTitle: '¿Cómo puedo ayudarte?',
    welcomeSubtitle: 'Haz una pregunta sobre cualquier tema jurídico',
    summarizeLegalText: 'Resumir Texto Jurídico',
    summarizeLegalTextDesc: 'Envía procesos, peticiones, apelaciones o preguntas de examen',
    images: 'Imágenes',
    photos: 'Fotos',
    aiAnalysis: 'Análisis con IA',
    premiumAnalysisActive: 'Análisis Premium Activado',
    eLawyerTitle: 'E-Lawyer - Abogado Virtual',
    eLawyerDesc: 'Consulta un abogado virtual especializado en TODAS las áreas del Derecho',
    areaCivil: 'Civil',
    areaPenal: 'Penal',
    areaLabor: 'Laboral',
    areaConstitutional: 'Constitucional',
    areaAdministrative: 'Administrativo',
    areaTax: 'Tributario',
    andMore: '¡Y mucho más!',
    premiumConsultActive: 'Consultoría Premium Activada - Respuestas Especializadas',
    sessionExpired: 'Sesión expirada. Inicie sesión nuevamente.',
    newConvStarted: 'Nueva conversación iniciada',
    confirmDeleteConv: '¿Desea realmente eliminar esta conversación?',
    convDeleted: '¡Conversación eliminada con éxito!',
    errorDeleteConv: 'Error al eliminar conversación',
    confirmClearAll: '¿Desea realmente borrar todo el historial de conversaciones? Las conversaciones favoritas se mantendrán.',
    historyCleared: '¡Historial borrado con éxito!',
    errorClearHistory: 'Error al borrar historial',
    addToFavorites: 'Añadir a favoritos',
    removeFromFavorites: 'Quitar de favoritos',
    addedToFavorites: 'Conversación añadida a favoritos',
    removedFromFavorites: 'Conversación quitada de favoritos',
    errorToggleFavorite: 'Error al marcar conversación como favorita',
    noConversationsToClear: 'No hay conversaciones para borrar',
    showFavoritesOnly: 'Mostrar solo favoritas',
    showAllConversations: 'Mostrar todas las conversaciones',
    noFavoriteConversations: 'Aún no hay conversaciones favoritas',
    noConversationsYet: 'Aún no hay conversaciones',
    noSearchResults: 'Sin resultados',
    unsupportedFormat: 'Formato no soportado. Use imágenes (JPG, PNG) o PDF',
    fileTooLarge: 'Archivo demasiado grande. Máximo 10MB',
    analyzingDoc: 'Analizando documento...',
    premiumAnalysisDone: '¡Análisis Premium Completado!',
    docAnalyzed: '¡Documento Analizado!',
    errorAnalyzeDoc: 'Error al analizar documento. Intente nuevamente.',
    errorProcessQuestion: 'Error al procesar pregunta',
    logoutSuccess: 'Sesión cerrada con éxito',
    legalAssistant: 'Asistente Jurídico',
    eLawyerHeaderDesc: 'Consultoría jurídica especializada en todas las áreas del Derecho',
    askAnythingAboutLaw: 'Pregunte cualquier duda sobre Derecho',
    chatExportedPdf: '¡Conversación exportada como PDF!',
    errorExportChat: 'Error al exportar conversación',
    fileSelected: 'Archivo seleccionado',
    addComment: 'Agregue un comentario (opcional)',
    sendFileForAnalysis: 'Enviar archivo para análisis',
    suggestion1: 'Explique el concepto de usucapión',
    suggestion2: 'Diferencia entre dolo y culpa',
    suggestion3: '¿Cómo calcular la pena base?',
    suggestion4: '¿Qué es la posesión?',
    searchConversation: 'Buscar conversación...',
    errorAnswerRecord: 'Error al registrar respuesta',
    filterByArea: 'Filtrar por área:',
    allAreas2: 'Todas las Áreas',
    questionOf: 'Pregunta',
    of: 'de',
    correctAnswer: '¡Respuesta Correcta!',
    incorrectAnswer: 'Respuesta Incorrecta',
    completedAllQuestions: '¡Completaste todas las preguntas de esta área!',
    nextQuestion: 'Siguiente Pregunta',
    completedAll: '¡Completaste todas las preguntas!',
    loadingQuestions: 'Cargando preguntas...',
    noQuestionsFound: 'No se encontraron preguntas para esta área',
    viewAll: 'Ver Todas',
    accuracy: 'de acierto',
    loginToAccessQuestions: 'Inicie sesión para acceder a las preguntas',
    errorLoadQuestions: 'Error al cargar preguntas',
    docSent: 'Documento enviado',
    allRightsReserved: '© 2025 Law Study A.I. Todos los derechos reservados.',
    availableLanguages: 'Idiomas: Portugués, Inglés, Español, Francés',
    
    // Ebook Index
    tableOfContents: 'Índice',
    page: 'Página',
    
    // Presentation Mode
    presentationMode: 'Presentar',
    exitPresentation: 'Salir',
    pressEscToExit: 'Presione ESC para salir',
    
    // Videos
    videosTitle: 'Videos Educativos',
    videosSubtitle: 'Genera videos animados sobre temas jurídicos con narración de audio',
    videoPromptLabel: 'Describe el tema del video *',
    videoPromptPlaceholder: 'Ej: Explique el concepto de habeas corpus y cuándo puede utilizarse...',
    videoLanguageLabel: 'Idioma del video',
    videoSubtitlesLabel: 'Incluir subtítulos',
    videoDurationLabel: 'Duración del video',
    videoGenerate: 'Generar Video',
    videoGenerating: 'Generando...',
    videoHistory: 'Historial',
    videoNoHistory: 'Ningún video generado aún',
    videoStatusQueued: 'En cola',
    videoStatusScript: 'Generando guion...',
    videoStatusAudio: 'Generando narración...',
    videoStatusVideo: 'Generando animación...',
    videoSceneLabel: 'Escena',
    videoSceneOfLabel: 'de',
    videoStatusMerging: 'Montando video final...',
    videoStatusCompleted: 'Completado',
    videoStatusError: 'Error',
    videoSeconds: 'segundos',
    videoDeleteConfirm: '¿Desea realmente eliminar este video?',
    videoDeleted: 'Video eliminado',
    videoRetry: 'Intentar de nuevo',
    videoRetryHint: 'Prompt copiado. Haga clic en Generar para intentar de nuevo.',
    videoNarration: 'Guion de Narración',
    videoSubtitlesText: 'Subtítulos',
    videoSubtitlesToggle: 'Subtítulos',
    videoGenerateSuccess: '¡Video iniciado! Siga el progreso abajo.',
    videoGenerateError: 'Error al generar video',
    navVideos: 'Videos',
    videoShare: 'Compartir',
    videoCopyLink: 'Copiar Enlace',
    videoLinkCopied: '¡Enlace Copiado!',
    videoDownload: 'Descargar',
    videoMinutes: 'minutos',
    galleryTitle: 'Galería de Videos',
    gallerySubtitle: 'Explore videos educativos compartidos por la comunidad',
    gallerySearch: 'Buscar por tema...',
    galleryEmpty: 'Ningún video en la galería aún',
    galleryEmptyDesc: '¡Sea el primero en compartir un video educativo!',
    galleryCreateVideo: 'Crear Video',
    navGallery: 'Galería'
  },

  fr: {
    // General
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    save: 'Enregistrer',
    back: 'Retour',
    next: 'Suivant',
    
    // Auth
    login: 'Connexion',
    register: "S'inscrire",
    email: 'E-mail',
    password: 'Mot de passe',
    name: 'Nom',
    alreadyHaveAccount: 'Vous avez déjà un compte?',
    dontHaveAccount: "Vous n'avez pas de compte?",
    loginWithGoogle: 'Se connecter avec Google',
    loginGoogleOnly: 'Ce compte utilise la connexion Google. Veuillez vous connecter avec Google.',
    loginError: 'Email ou mot de passe invalide',
    loginSuccess: 'Connexion réussie !',
    registerSuccess: 'Compte créé avec succès !',
    registerError: 'Erreur lors de la création du compte',
    registerEmailExists: 'Cet email est déjà enregistré',
    welcome: 'Bienvenue',
    askQuestion: 'Posez une question sur le Droit...',
    send: 'Envoyer',
    clearHistory: 'Effacer l\'Historique',
    clearConversation: 'Effacer la Conversation',
    newConversation: 'Nouvelle Conversation',
    conversationHistory: 'Historique des Conversations',
    logout: 'Se Déconnecter',
    language: 'Langue',
    aiAssistant: 'Assistant IA Juridique',
    typeMessage: 'Tapez votre message...',
    
    // Navigation
    questions: 'Questions',
    quiz: 'Quiz Éducatif',
    mindMaps: 'Cartes Mentales',
    ebooks: 'E-books',
    myLibrary: '',
    subscription: 'Abonnement',
    
    // E-books
    ebooksTitle: 'Bibliothèque d\'E-books Juridiques',
    ebooksDescription: 'E-books spécialisés pour seulement R$ 25,00 chacun',
    subscriberAccess: 'Accès illimité à tous les e-books',
    subscriberAccessDesc: 'Votre abonnement inclut l\'accès gratuit à toute la bibliothèque d\'e-books',
    ebooksSubtitle: 'Matériels pédagogiques complets pour vos études',
    allAreas: 'Tous',
    free: 'Gratuit',
    buy: 'Acheter',
    read: 'Lire',
    noEbooksFound: 'Aucun e-book trouvé',
    searchPlaceholder: 'Rechercher par titre, domaine ou description...',
    
    // Landing Page
    heroTitle: 'Étudiez le Droit avec l\'Intelligence Artificielle',
    heroDescription: 'Obtenez des réponses à vos questions juridiques avec notre IA spécialisée en Droit brésilien',
    howItWorks: 'Comment ça marche',
    featuresTitle: 'Fonctionnalités Exclusives',
    aiAssistantFeature: 'Assistant IA Juridique',
    aiAssistantDesc: 'Chat intelligent pour répondre aux questions juridiques',
    ebooksFeature: 'E-books Spécialisés',
    ebooksFeatureDesc: 'Bibliothèque complète de matériels pédagogiques',
    quizFeature: 'Quiz Interactif',
    quizFeatureDesc: 'Testez vos connaissances avec des questions',
    mindMapsFeature: 'Cartes Mentales',
    mindMapsFeatureDesc: 'Visualisez les concepts clairement',
    pricingTitle: 'Choisissez votre Plan',
    pricingSubtitle: 'Plans flexibles pour vos études',
    mostPopular: 'Le Plus Populaire',
    objectiveExamples: 'Exemples objectifs',
    basicSupport: 'Support basique',
    premiumSummaries: 'Résumés premium',
    bookRecommendations: 'Recommandations de livres',
    advancedExamples: 'Exemples avancés',
    everythingInMonthly: 'Tout du Mensuel',
    save79: 'Économisez 79%',
    exclusiveContent: 'Contenu exclusif',
    popularTopics: 'Sujets Populaires',
    topicUsucapiao: 'Usucapion',
    topicPosse: 'Possession',
    topicPropriedade: 'Propriété',
    topicPena: 'Peine',
    topicDolo: 'Dol',
    topicCulpa: 'Faute',
    topicObrigacoes: 'Obligations',
    topicContratos: 'Contrats',
    topicSucessao: 'Succession',
    topicFamilia: 'Famille',

    // Subscription Page
    subActivatedSuccess: 'Abonnement activé avec succès !',
    aiAccess: 'Accès à une IA spécialisée',
    prioritySupport: 'Support prioritaire',
    earlyAccess: 'Accès anticipé aux nouvelles fonctionnalités',
    professionalAnswers: 'Réponses professionnelles de pointe',
    payOnceYear: 'Paiement une seule fois par an',
    subCurrentPlan: 'Plan Actuel',
    subUpgradeFreeHint: 'Passez à un plan supérieur pour débloquer les fonctionnalités premium',
    premiumFeatures: 'Fonctionnalités Premium',
    subChoosePlan: 'Choisissez Votre Plan',
    subAccelerateStudies: 'Accélérez vos études avec des fonctionnalités IA avancées',
    subSubscribeNow: "S'abonner Maintenant",
    subPlanActive: 'Plan Actif',
    subWhyUpgrade: 'Pourquoi passer à un plan supérieur ?',
    subBenefit1Title: 'Résumés Premium',
    subBenefit1Desc: 'Contenu plus détaillé, exemples pratiques et explications approfondies',
    subBenefit2Title: 'Recherche Illimitée',
    subBenefit2Desc: 'Sans limite de recherches. Cherchez autant de fois que nécessaire',
    subBenefit3Title: 'Bibliographie',
    subBenefit3Desc: 'Recommandations de livres et références spécialisées',
    subModalTitle: "Finaliser l'Abonnement Premium",
    subModalItemTitleWeekly: 'Abonnement Hebdomadaire',
    subModalItemTitleMonthly: 'Abonnement Mensuel',
    subModalItemTitleAnnual: 'Abonnement Annuel',

    // Mercado Pago Checkout
    mpPublicKeyMissing: 'Clé publique Mercado Pago non configurée',
    mpInitError: 'Erreur lors du chargement du système de paiement. Essayez de recharger la page.',
    mpInitErrorToast: "Erreur lors de l'initialisation du paiement",
    mpPaymentApproved: 'Paiement approuvé !',
    mpPaymentPending: 'Paiement en attente. En attente de confirmation.',
    mpPaymentNotApproved: "Le paiement n'a pas été approuvé. Veuillez réessayer.",
    mpPaymentError: 'Erreur lors du traitement du paiement',
    mpMustBeLoggedIn: 'Vous devez être connecté',
    mpPixGenerated: 'PIX généré avec succès !',
    mpQrNotGenerated: "Le code QR n'a pas été généré. Veuillez réessayer.",
    mpPixError: 'Erreur lors de la génération du PIX',
    mpBoletoGenerated: 'Billet bancaire généré avec succès !',
    mpBoletoNotGenerated: "Le billet bancaire n'a pas été généré. Veuillez réessayer.",
    mpBoletoError: 'Erreur lors de la génération du billet bancaire',
    mpNotConfiguredTitle: 'Système de Paiement Non Configuré',
    mpNotConfiguredDesc: "La clé publique Mercado Pago n'a pas été trouvée.",
    mpNotConfiguredEnvHint: 'Configurez REACT_APP_MERCADO_PAGO_PUBLIC_KEY dans le fichier .env',
    mpChooseMethodTitle: 'Choisissez le Mode de Paiement',
    mpSelectHowToPay: 'Sélectionnez comment vous souhaitez payer :',
    mpAutoRenewal: 'Renouvellement automatique',
    mpImmediateApproval: 'Approbation immédiate',
    mpOneTimeMonthlyPayment: 'Paiement unique mensuel',
    mpOneTimeWeeklyPayment: 'Paiement unique hebdomadaire',
    mpOneTimeAnnualPayment: 'Paiement unique annuel',
    mpInstantPayment: 'Paiement instantané',
    mpDueIn3Days: 'Échéance dans 3 jours',
    mpPaymentSystemErrorTitle: 'Erreur du Système de Paiement',
    mpReloadPage: 'Recharger la Page',
    mpLoadingPaymentSystem: 'Chargement du système de paiement...',
    mpPleaseWait: "Veuillez patienter",
    mpCardProcessError: 'Erreur lors du traitement de la carte. Veuillez réessayer.',
    mpGeneratingPix: 'Génération du PIX...',
    mpGeneratePix: 'Générer le PIX',
    mpPixSuccessTitle: 'PIX Généré avec Succès !',
    mpPixCodeLabel: 'Code PIX (Copier et Coller) :',
    mpCodeCopied: 'Code copié !',
    mpCopy: 'Copier',
    mpPixImportantTitle: 'Important à propos du Paiement via PIX',
    mpPixOnceNotAutoRenewed: "Le paiement via PIX est unique et N'EST PAS renouvelé automatiquement. Vous devrez payer à nouveau lorsque la période expirera pour garder votre abonnement actif.",
    mpPixAutoRenewalPrefix: 'Pour un renouvellement automatique, choisissez',
    mpHowToPayTitle: 'Comment payer :',
    mpPixStep1: 'Ouvrez l\'application de votre banque',
    mpPixStep2: 'Choisissez de payer avec PIX',
    mpPixStep3: 'Scannez le code QR ou collez le code',
    mpPixStep4Prefix: 'Confirmez le paiement de',
    mpPixProcessedInstantly: 'Le paiement est traité instantanément après confirmation',
    mpAlreadyPaid: "J'ai Déjà Payé",
    mpBoletoWillBeGenerated: 'Le billet bancaire sera généré et vous pourrez le payer dans n\'importe quelle banque.',
    mpGeneratingBoleto: 'Génération du Billet Bancaire...',
    mpGenerateBoleto: 'Générer le Billet Bancaire',
    mpBoletoSuccessTitle: 'Billet Bancaire Généré avec Succès !',
    mpBoletoLineLabel: 'Ligne du Billet Bancaire :',
    mpLineCopied: 'Ligne copiée !',
    mpValueLabel: 'Montant :',
    mpDueDateLabel: 'Échéance :',
    mpBeneficiaryLabel: 'Bénéficiaire :',
    mpViewPrintBoleto: 'Voir/Imprimer le Billet Bancaire',
    mpBoletoStep1: 'Copiez la ligne ci-dessus',
    mpBoletoStep2: 'Accédez à l\'application ou au site de votre banque',
    mpBoletoStep3: 'Choisissez "Payer le Billet"',
    mpBoletoStep4: 'Collez la ligne',
    mpBoletoStep5: "Confirmez le paiement avant la date d'échéance",
    mpBoletoConfirmTime: 'Le billet bancaire prend 1 à 3 jours ouvrables pour être confirmé après paiement',
    mpProcessingPayment: 'Traitement du paiement...',

    // Auth Callback / Mind Map / Quiz Analytics
    authProcessing: "Traitement de l'authentification...",
    mmPdfSaved: 'PDF enregistré avec succès !',
    mmPdfError: 'Erreur lors de la génération du PDF',
    mmLinkCopied: 'Lien copié !',
    mmLinkCreatedCopied: 'Lien créé et copié !',
    mmShareError: 'Erreur lors de la génération du lien de partage',
    mmLightMode: 'Clair',
    mmPrintMode: 'Impression',
    mmCopied: 'Copié !',
    mmCopyLink: 'Copier',
    mmShare: 'Partager',
    mmClose: 'Fermer',
    qaTrend: 'Tendance',
    qaImproving: 'En amélioration',
    qaAttention: 'Attention',
    qaStable: 'Stable',
    qaScoreEvolution: 'Évolution des Notes',
    qaAccuracy: 'Précision',
    qaPerformanceByArea: 'Performance par Domaine',

    // Shared Map / Shared Slides
    smMapNotFound: 'Carte introuvable ou lien expiré.',
    smMapNotFoundFallback: 'Carte introuvable',
    smLinkIncorrectHint: 'Le lien est peut-être incorrect ou la carte a été supprimée.',
    smBackHome: "Retour à l'Accueil",
    ssPresentationNotFound: 'Présentation introuvable ou lien expiré.',
    ssInvalidLink: 'Lien invalide',
    ssSharedPresentation: 'Présentation Partagée',
    ssSlideLabel: 'Diapositive',
    ssPrevious: 'Précédent',
    ssNext: 'Suivant',
    ssFooterGenerated: "Généré par Law Study A.I — Utilisez les flèches du clavier pour naviguer",

    // Ebook Detail Page
    ebdNotFound: 'E-book introuvable',
    ebdLoading: "Chargement de l'e-book...",
    ebdFreeBadge: 'GRATUIT',
    ebdLoginToBuy: 'Connectez-vous pour acheter des e-books',
    ebdAddedToLibrary: 'E-book ajouté à votre bibliothèque !',
    ebdPurchasedForPrefix: 'E-book acheté pour',
    mocked: 'simulé',
    ebdPurchaseError: "Erreur lors de l'achat de l'e-book",
    ebdActiveSubscription: 'Abonnement actif — accès complet',
    ebdReadEbook: "Lire l'E-book",
    ebdViewAllEbooks: 'Voir Tous les E-books',
    ebdLoginToBuySimple: 'Connectez-vous pour acheter',
    ebdGetFree: 'Obtenir Gratuitement',
    ebdBuyNow: 'Acheter Maintenant',
    ebdLoginLink: 'Connectez-vous',
    ebdToBuyThisEbook: 'pour acheter cet e-book',
    ebdPurchaseSuccess: 'Achat effectué avec succès !',
    ebdWhatYouWillLearn: 'Ce que vous allez apprendre :',
    ebdFeature1: 'Contenu spécialisé et pédagogique',
    ebdFeature2: 'Exemples pratiques et cas réels',
    ebdFeature3: 'Législation à jour',
    ebdFeature4: "Accès à vie après l'achat",

    // Atualizações Jurídicas (list + detail)
    audNotFound: 'Mise à jour introuvable',
    audLoginToFavorite: 'Connectez-vous pour ajouter aux favoris',
    audFavoriteError: "Erreur lors de l'ajout aux favoris",
    audLinkCopied: 'Lien copié !',
    audTypeNoticia: 'Actualité',
    audTypeLegislacao: 'Législation',
    audTypeJurisprudencia: 'Jurisprudence',
    audTypeArtigo: 'Article',
    audBrazilianLaw: 'Droit Brésilien',
    audInternationalLaw: 'Droit International',
    audSourceLabel: 'Source :',
    audViewOriginalSource: 'Voir la source originale',
    audFavorited: 'Favori',
    audFavoriteAction: 'Ajouter aux Favoris',
    audBackToUpdates: 'Retour aux mises à jour',
    ajErrorLoading: 'Erreur lors du chargement des mises à jour',
    ajLoginToFavorite: 'Connectez-vous pour ajouter des mises à jour aux favoris',
    ajAddedToFavorites: 'Ajouté aux favoris',
    ajRemovedFromFavorites: 'Retiré des favoris',
    ajNewUpdatesAdded: 'nouvelles mises à jour ajoutées !',
    ajNoNewUpdates: 'Aucune nouvelle mise à jour trouvée',
    ajSyncError: 'Erreur lors de la synchronisation des actualités',
    ajLoadingUpdates: 'Chargement des mises à jour...',
    ajPageTitle: 'Mises à Jour Juridiques',
    ajPageSubtitle: 'Contenu juridique de Droit Brésilien et International toujours à jour',
    ajSearchPlaceholder: 'Rechercher des mises à jour...',
    ajHideFilters: 'Masquer les Filtres',
    ajShowFilters: 'Afficher les Filtres',
    ajSearching: 'Recherche...',
    ajSearchNews: 'Rechercher des Actualités',
    ajCategory: 'Catégorie',
    ajAll: 'Toutes',
    ajType: 'Type',
    ajArea: 'Domaine',
    ajAreaCivil: 'Droit Civil',
    ajAreaPenal: 'Droit Pénal',
    ajAreaLabor: 'Droit du Travail',
    ajAreaConstitutional: 'Droit Constitutionnel',
    ajAreaAdministrative: 'Droit Administratif',
    ajAreaTax: 'Droit Fiscal',
    ajAreaInternational: 'Droit International',
    ajClearFilters: 'Effacer les Filtres',
    ajUpdatesFound: 'mises à jour trouvées',
    ajBrazilShort: 'Brésilien',
    ajInternationalShort: 'International',
    ajReadOriginalSource: 'Lire la source originale',
    ajNoUpdatesFound: 'Aucune mise à jour trouvée',
    ajTryAdjustingFilters: "Essayez d'ajuster les filtres ou de rechercher d'autres termes",

    // Quiz Page
    qzLoginRequired: 'Veuillez vous connecter pour accéder aux quiz',
    qzFillAllFields: 'Veuillez remplir tous les champs',
    qzGeneratedSuccess: 'Quiz généré avec succès !',
    qzGenerateError: 'Erreur lors de la génération du quiz',
    qzSelectAnswer: 'Sélectionnez une réponse',
    qzCompletedToastPrefix: 'Quiz terminé ! Vous avez obtenu',
    qzOf: 'sur',
    qzQuestionsWord: 'questions',
    qzSubmitError: "Erreur lors de l'envoi du quiz",
    qzHistoryError: "Erreur lors du chargement de l'historique",
    qzBack: 'Retour',
    qzViewHistory: "Voir l'Historique",
    qzTitle: 'Quiz Éducatif',
    qzSubtitle: 'Testez vos connaissances et apprenez avec des explications détaillées',
    qzAreaLabel: 'Domaine du Droit',
    qzSelectArea: 'Sélectionnez le domaine',
    qzQuestionTypeLabel: 'Type de Questions',
    qzSelectType: 'Sélectionnez le type',
    qzMultipleChoice: 'Choix Multiple',
    qzTrueFalse: 'Vrai ou Faux',
    qzMixed: 'Mixte (Les deux)',
    qzDifficultyLabel: 'Niveau de Difficulté',
    qzSelectLevel: 'Sélectionnez le niveau',
    qzBasic: 'Basique',
    qzIntermediate: 'Intermédiaire',
    qzAdvanced: 'Avancé',
    qzNumQuestionsLabel: 'Nombre de Questions',
    qzGenerating: 'Génération du Quiz...',
    qzGenerateBtn: 'Générer le Quiz',
    qzQuestionWord: 'Question',
    qzPreviousBtn: 'Précédent',
    qzFinishQuiz: 'Terminer le Quiz',
    qzNextBtn: 'Suivant',
    qzCompletedTitle: 'Quiz Terminé !',
    qzYouGot: 'Vous avez obtenu',
    qzExcellent: 'Excellent !',
    qzGoodJob: 'Bon travail !',
    qzKeepStudying: 'Continuez à étudier !',
    qzYourAnswer: 'Votre réponse :',
    qzCorrectAnswer: 'Réponse correcte :',
    qzExplanationLabel: 'Explication :',
    qzNewQuiz: 'Nouveau Quiz',
    qzGeneralStats: 'Statistiques Générales',
    qzStatQuizzes: 'Quiz',
    qzStatCorrect: 'Réussites',
    qzStatQuestions: 'Questions',
    qzStatPerformance: 'Performance',
    qzHistoryTitle: 'Historique des Quiz',
    qzNoQuizzesYet: 'Aucun quiz réalisé pour le moment',
    qzFirstQuiz: 'Faire le Premier Quiz',
    qzVF: 'V/F',
    qzRestrictedAccess: 'Accès Restreint',
    qzLoginToAccess: 'Vous devez vous connecter pour accéder aux quiz éducatifs',
    qzDoLogin: 'Se Connecter',
    qzAreaBusiness: 'Droit des Affaires',
    qzAreaCivilProcedure: 'Droit de la Procédure Civile',
    qzAreaCriminalProcedure: 'Droit de la Procédure Pénale',
    qzAreaConsumer: 'Droit de la Consommation',
    
    // Payment
    paymentMethods: 'Méthodes de Paiement',
    pix: 'PIX',
    creditCard: 'Carte de Crédit',
    boleto: 'Billet Bancaire',
    
    // Quiz
    quizTitle: 'Quiz Éducatif',
    selectArea: 'Sélectionner le Domaine',
    selectType: 'Type de Questions',
    selectLevel: 'Niveau de Difficulté',
    numberOfQuestions: 'Nombre de Questions',
    startQuiz: 'Commencer le Quiz',
    
    // Mind Maps
    mindMapsTitle: 'Cartes Mentales Juridiques',
    mindMapsDescription: 'Résumés visuels des principaux sujets du Droit',
    
    // Subscription
    subscriptionPlans: "Plans d'Abonnement",
    weekly: 'Hebdomadaire',
    monthly: 'Mensuel',
    annual: 'Annuel',
    subscribe: "S'abonner",
    
    // Landing Page
    landingTitle: 'Simplifiez vos Études Juridiques',
    landingSubtitle: "Plateforme IA pour Étudiants en Droit",
    getStarted: 'Commencer',
    features: 'Fonctionnalités',
    pricing: 'Tarifs',
    
    // More sections
    premiumAccess: 'Accès Premium',
    unlimitedSearch: 'Recherches illimitées',
    detailedSummaries: 'Résumés détaillés',
    practicalExamples: 'Exemples pratiques',
    specializedBibliography: 'Bibliographie spécialisée',
    perWeek: 'par semaine',
    perMonth: 'par mois',
    perYear: 'par an',
    chooseArea: 'Choisir le Domaine',
    difficulty: 'Difficulté',
    basic: 'Basique',
    intermediate: 'Intermédiaire',
    advanced: 'Avancé',
    correct: 'Correct',
    incorrect: 'Incorrect',
    score: 'Score',
    total: 'Total',
    explanation: 'Explication',
    continue: 'Continuer',
    finish: 'Terminer',
    results: 'Résultats',
    yourScore: 'Votre Score',
    correctAnswers: 'Bonnes Réponses',
    viewDetails: 'Voir les Détails',
    tryAgain: 'Réessayer',
    backToDashboard: 'Retour au Tableau de Bord',
    purchase: 'Acheter',
    price: 'Prix',
    lifetimeAccess: 'Accès à vie',
    paymentMethod: 'Méthode de Paiement',
    processing: 'Traitement...',
    purchased: 'Acheté',
    alreadyPurchased: 'Déjà Acheté',
    scanQRCode: 'Scanner le Code QR',
    copyCode: 'Copier le Code',
    alreadyPaid: 'Déjà Payé',
    generating: 'Génération...',
    viewLibrary: 'Voir la Bibliothèque',
    noItems: 'Aucun élément',
    history: 'Historique',
    statistics: 'Statistiques',
    attempts: 'Tentatives',
    averageScore: 'Score Moyen',
    byArea: 'Par Domaine',
    backToHome: 'Retour à l\'accueil',
    orSeparator: 'ou',
    legalUpdates: 'Actualités Juridiques',
    choosePlan: 'Choisir le Plan',
    dashboard: 'Tableau de bord',

    // Créer Page
    criarTitle: 'Créer',
    criarPecasProcessuais: 'Pièces Judiciaires',
    criarApresentacoes: 'Présentations',
    criarNovoDocumento: 'Nouveau Document',
    criarNenhumDocumento: 'Aucun document pour le moment',
    criarGerarPeca: 'Générer une Pièce Judiciaire',
    criarGerarPecaDesc: 'Remplissez les données et l\'IA créera la pièce complète avec un fondement juridique réel',
    criarGerarApresentacao: 'Générer une Présentation',
    criarGerarApresentacaoDesc: 'Entrez le sujet juridique et recevez des diapositives professionnelles prêtes à présenter',
    criarTipoPeca: 'Type de Pièce',
    criarSelecioneTipo: 'Sélectionnez le type...',
    criarNomeAutor: 'Nom du Demandeur/Requérant',
    criarPlaceholderAutor: 'Ex : Jean Dupont',
    criarDadosAutor: 'Données du Demandeur',
    criarPlaceholderDadosAutor: 'Pièce d\'identité, adresse, profession...',
    criarNomeReu: 'Nom du Défendeur/Intimé',
    criarPlaceholderReu: 'Ex : Société XYZ SARL',
    criarDadosReu: 'Données du Défendeur',
    criarPlaceholderDadosReu: 'SIRET, adresse...',
    criarAutorNomeCompleto: 'Nom complet',
    criarAutorDocumento: 'Pièce d\'identité / N° fiscal',
    criarPlaceholderAutorDoc: 'Ex : 123 456 789',
    criarAutorProfissao: 'Profession',
    criarPlaceholderAutorProf: 'Ex : Commerçant',
    criarAutorEndereco: 'Adresse',
    criarPlaceholderAutorEnd: 'Rue, numéro, quartier, ville',
    criarReuNomeCompleto: 'Nom complet / Raison sociale',
    criarReuDocumento: 'Pièce d\'identité / SIRET',
    criarPlaceholderReuDoc: 'Ex : 123 456 789 00001',
    criarReuEndereco: 'Adresse',
    criarPlaceholderReuEnd: 'Rue, numéro, quartier, ville',
    criarForo: 'Tribunal / Juridiction',
    criarPlaceholderForo: 'Ex : 3e Tribunal Civil de São Paulo/SP',
    criarSituacao: 'Situation / Faits',
    criarPlaceholderSituacao: 'Décrivez en détail les faits, le problème juridique et ce que vous souhaitez obtenir...',
    criarGerandoPeca: 'Génération de la pièce...',
    criarTemaApresentacao: 'Thème de la Présentation',
    criarPlaceholderTema: 'Ex : Principes du Droit Pénal Brésilien',
    criarNumSlides: 'Nombre de Diapositives',
    criarDetalhesAdicionais: 'Détails Supplémentaires',
    criarPlaceholderDetalhes: 'Focus jurisprudence ? Niveau académique ? Public cible ?',
    criarGerandoApresentacao: 'Génération de la présentation...',
    criarAnterior: 'Précédent',
    criarProximo: 'Suivant',
    criarAutorLabel: 'Demandeur',
    criarReuLabel: 'Défendeur',
    criarForoLabel: 'Tribunal',
    criarPreenchaCampos: 'Veuillez remplir tous les champs obligatoires',
    criarInformeTema: 'Veuillez entrer le thème de la présentation',
    criarRecursoExclusivo: 'Fonctionnalité réservée aux abonnés',
    criarPecaGerada: 'Pièce judiciaire générée avec succès !',
    criarErroPeca: 'Erreur lors de la génération de la pièce',
    criarApresentacaoGerada: 'Présentation générée avec succès !',
    criarErroSlides: 'Erreur lors de la génération des diapositives',
    criarExportadoComo: 'Exporté en',
    criarErroExportar: 'Erreur lors de l\'exportation du document',
    criarErroCarregar: 'Erreur lors du chargement du document',
    criarDocExcluido: 'Document supprimé',
    criarErroExcluir: 'Erreur lors de la suppression',
    criarPeticaoInicial: 'Pétition Initiale',
    criarContestacao: 'Contestation',
    criarApelacao: 'Appel',
    criarMandadoSeguranca: 'Mandat de Sécurité',
    criarHabeasCorpus: 'Habeas Corpus',
    criarRecursoEspecial: 'Recours Spécial',
    criarAgravo: 'Appel Interlocutoire',
    criarReconvencao: 'Demande Reconventionnelle',
    criarEmbargosDeclaracao: 'Motion en Clarification',
    criarAcaoIndenizacao: 'Action en Indemnisation',
    criarSlides: 'diapositives',
    criarSalvarRascunho: 'Enregistrer le Brouillon',
    criarRascunhoSalvo: 'Brouillon enregistré avec succès !',
    criarRascunhoAtualizado: 'Brouillon mis à jour !',
    criarErroRascunho: 'Erreur lors de l\'enregistrement du brouillon',
    criarRascunhos: 'Brouillons',
    criarRascunhoExcluido: 'Brouillon supprimé',
    criarEditarRascunho: 'Modifier le brouillon',
    criarGerarDoRascunho: 'Générer depuis ce Brouillon',
    criarSalvando: 'Enregistrement...',

    // Cartes Mentales Custom
    mapasCriar: 'Créer une Carte Mentale',
    mapasTema: 'Thème de la Carte Mentale',
    mapasPlaceholderTema: 'Ex : Droit Pénal - Crimes contre les personnes',
    mapasProfundidade: 'Niveau de Profondeur',
    mapasBasico: 'Basique (3 sujets)',
    mapasIntermediario: 'Intermédiaire (5 sujets)',
    mapasAvancado: 'Avancé (7 sujets)',
    mapasGerar: 'Générer la Carte Mentale',
    mapasGerando: 'Génération de la carte mentale...',
    mapasGerado: 'Carte mentale générée avec succès !',
    mapasErro: 'Erreur lors de la génération de la carte mentale',
    mapasMeus: 'Mes Cartes',
    mapasExcluido: 'Carte supprimée',
    mapasNenhum: 'Aucune carte créée pour le moment',
    mapasAprendizado: 'Apprentissage Visuel',
    mapasTitulo: 'Cartes Mentales Juridiques',
    mapasDescricao: 'Résumés visuels des principaux thèmes du Droit avec des exemples pratiques',
    mapasComoUsar: 'Comment utiliser les Cartes Mentales ?',
    mapasTopicsCount: 'sujets',
    mapasSubtopicsCount: 'sous-sujets',
    mapasHowToUse1: 'Cliquez sur "Voir" pour afficher la carte mentale en format arbre interactif',
    mapasHowToUse2: 'Survolez les nœuds pour voir les détails et exemples',
    mapasHowToUse3: 'Utilisez le bouton PDF pour enregistrer et imprimer votre carte mentale',
    ebooksLoadError: 'Erreur lors du chargement des e-books',
    dashAnalyzeImage: "Analyser l'image",
    dashHidePanel: 'Masquer le panneau',
    dashShowPanel: 'Afficher le panneau',
    untitledConversation: 'Sans titre',
    dashImageSentAlt: 'Image envoyée',
    mapasFavoriteError: "Erreur lors de l'ajout aux favoris",
    mapasConfirmDelete: 'Voulez-vous supprimer cette carte mentale ?',
    ebooksLoading: 'Chargement des e-books...',
    erpMustPurchaseFirst: "Vous devez d'abord acheter cet e-book",
    erpLoadContentError: 'Erreur lors du chargement du contenu',
    erpTranslationTimeout: 'Délai de traduction dépassé. Veuillez réessayer.',
    erpTranslationServerError: 'Erreur du serveur de traduction. Veuillez réessayer plus tard.',
    erpTranslatePageError: 'Erreur lors de la traduction de la page',
    erpEbookInPortuguese: 'E-book en portugais',
    erpTranslatingTo: 'Traduction vers',
    erpTranslationAppliedPerPage: 'La traduction sera appliquée page par page',
    erpSelectLanguageForTranslation: 'Sélectionnez la langue de traduction',
    erpMainLanguages: 'Langues Principales',
    erpAsia: 'Asie',
    erpEurope: 'Europe',
    erpAfrica: 'Afrique',
    erpAmericasOceania: 'Amériques & Océanie',
    erpOtherLanguages: 'Autres Langues',
    erpTranslating: 'Traduction en cours...',
    erpTranslatingContent: 'Traduction du contenu...',
    erpChapter: 'Chapitre',
    erpPracticalExamples: 'Exemples Pratiques',
    erpPreviousPage: 'Page Précédente',
    erpNextPage: 'Page Suivante',
    erpNextChapter: 'Suivant',
    mapasClique: 'Cliquez sur les sujets pour développer et voir les détails',
    mapasExemplo: 'Chaque exemple pratique facilite la mémorisation',
    mapasGuia: 'Utilisez comme guide de révision rapide avant les examens',
    mapasCarregando: 'Chargement des cartes mentales...',
    mapasErroCarregar: 'Erreur lors du chargement des cartes mentales',

    // Welcome / Dashboard dynamic
    welcomeTitle: 'Comment puis-je vous aider ?',
    welcomeSubtitle: 'Posez une question sur n\'importe quel sujet juridique',
    summarizeLegalText: 'Résumer un Texte Juridique',
    summarizeLegalTextDesc: 'Envoyez des procès, pétitions, appels ou questions d\'examen',
    images: 'Images',
    photos: 'Photos',
    aiAnalysis: 'Analyse IA',
    premiumAnalysisActive: 'Analyse Premium Activée',
    eLawyerTitle: 'E-Lawyer - Avocat Virtuel',
    eLawyerDesc: 'Consultez un avocat virtuel spécialisé dans TOUS les domaines du Droit',
    areaCivil: 'Civil',
    areaPenal: 'Pénal',
    areaLabor: 'Travail',
    areaConstitutional: 'Constitutionnel',
    areaAdministrative: 'Administratif',
    areaTax: 'Fiscal',
    andMore: 'Et bien plus !',
    premiumConsultActive: 'Consultation Premium Activée - Réponses Spécialisées',
    sessionExpired: 'Session expirée. Veuillez vous reconnecter.',
    newConvStarted: 'Nouvelle conversation commencée',
    confirmDeleteConv: 'Voulez-vous vraiment supprimer cette conversation ?',
    convDeleted: 'Conversation supprimée avec succès !',
    errorDeleteConv: 'Erreur lors de la suppression de la conversation',
    confirmClearAll: 'Voulez-vous vraiment effacer tout l\'historique des conversations ? Les conversations favorites seront conservées.',
    historyCleared: 'Historique effacé avec succès !',
    errorClearHistory: 'Erreur lors de l\'effacement de l\'historique',
    addToFavorites: 'Ajouter aux favoris',
    removeFromFavorites: 'Retirer des favoris',
    addedToFavorites: 'Conversation ajoutée aux favoris',
    removedFromFavorites: 'Conversation retirée des favoris',
    errorToggleFavorite: 'Erreur lors de la mise en favori',
    noConversationsToClear: 'Aucune conversation à effacer',
    showFavoritesOnly: 'Afficher uniquement les favoris',
    showAllConversations: 'Afficher toutes les conversations',
    noFavoriteConversations: 'Aucune conversation favorite pour le moment',
    noConversationsYet: 'Aucune conversation pour le moment',
    noSearchResults: 'Aucun résultat',
    unsupportedFormat: 'Format non supporté. Utilisez des images (JPG, PNG) ou PDF',
    fileTooLarge: 'Fichier trop volumineux. Maximum 10 Mo',
    analyzingDoc: 'Analyse du document...',
    premiumAnalysisDone: 'Analyse Premium Terminée !',
    docAnalyzed: 'Document Analysé !',
    errorAnalyzeDoc: 'Erreur lors de l\'analyse du document. Veuillez réessayer.',
    errorProcessQuestion: 'Erreur lors du traitement de la question',
    logoutSuccess: 'Déconnexion réussie',
    legalAssistant: 'Assistant Juridique',
    eLawyerHeaderDesc: 'Consultation juridique spécialisée dans tous les domaines du Droit',
    askAnythingAboutLaw: 'Posez n\'importe quelle question sur le Droit',
    chatExportedPdf: 'Conversation exportée en PDF !',
    errorExportChat: 'Erreur lors de l\'exportation de la conversation',
    fileSelected: 'Fichier sélectionné',
    addComment: 'Ajoutez un commentaire (facultatif)',
    sendFileForAnalysis: 'Envoyer le fichier pour analyse',
    suggestion1: 'Expliquez le concept de prescription acquisitive',
    suggestion2: 'Différence entre intention et négligence',
    suggestion3: 'Comment calculer la peine de base ?',
    suggestion4: 'Qu\'est-ce que la possession ?',
    searchConversation: 'Rechercher une conversation...',
    errorAnswerRecord: 'Erreur lors de l\'enregistrement de la réponse',
    filterByArea: 'Filtrer par domaine :',
    allAreas2: 'Tous les Domaines',
    questionOf: 'Question',
    of: 'de',
    correctAnswer: 'Bonne Réponse !',
    incorrectAnswer: 'Mauvaise Réponse',
    completedAllQuestions: 'Vous avez terminé toutes les questions de ce domaine !',
    nextQuestion: 'Question Suivante',
    completedAll: 'Vous avez terminé toutes les questions !',
    loadingQuestions: 'Chargement des questions...',
    noQuestionsFound: 'Aucune question trouvée pour ce domaine',
    viewAll: 'Voir Toutes',
    accuracy: 'de réussite',
    loginToAccessQuestions: 'Connectez-vous pour accéder aux questions',
    errorLoadQuestions: 'Erreur lors du chargement des questions',
    docSent: 'Document envoyé',
    allRightsReserved: '© 2025 Law Study A.I. Tous droits réservés.',
    availableLanguages: 'Langues : Portugais, Anglais, Espagnol, Français',
    
    // Ebook Index
    tableOfContents: 'Table des matières',
    page: 'Page',
    
    // Presentation Mode
    presentationMode: 'Présenter',
    exitPresentation: 'Quitter',
    pressEscToExit: 'Appuyez sur ESC pour quitter',
    
    // Videos
    videosTitle: 'Vidéos Éducatives',
    videosSubtitle: 'Générez des vidéos animées sur des sujets juridiques avec narration audio',
    videoPromptLabel: 'Décrivez le sujet de la vidéo *',
    videoPromptPlaceholder: 'Ex : Expliquez le concept d\'habeas corpus et quand il peut être utilisé...',
    videoLanguageLabel: 'Langue de la vidéo',
    videoSubtitlesLabel: 'Inclure les sous-titres',
    videoDurationLabel: 'Durée de la vidéo',
    videoGenerate: 'Générer la Vidéo',
    videoGenerating: 'Génération...',
    videoHistory: 'Historique',
    videoNoHistory: 'Aucune vidéo générée encore',
    videoStatusQueued: 'En file',
    videoStatusScript: 'Génération du script...',
    videoStatusAudio: 'Génération de la narration...',
    videoStatusVideo: 'Génération de l\'animation...',
    videoSceneLabel: 'Scène',
    videoSceneOfLabel: 'sur',
    videoStatusMerging: 'Montage de la vidéo finale...',
    videoStatusCompleted: 'Terminé',
    videoStatusError: 'Erreur',
    videoSeconds: 'secondes',
    videoDeleteConfirm: 'Voulez-vous vraiment supprimer cette vidéo ?',
    videoDeleted: 'Vidéo supprimée',
    videoRetry: 'Réessayer',
    videoRetryHint: 'Prompt copié. Cliquez sur Générer pour réessayer.',
    videoNarration: 'Script de Narration',
    videoSubtitlesText: 'Sous-titres',
    videoSubtitlesToggle: 'Sous-titres',
    videoGenerateSuccess: 'Vidéo lancée ! Suivez la progression ci-dessous.',
    videoGenerateError: 'Erreur lors de la génération de la vidéo',
    navVideos: 'Vidéos',
    videoShare: 'Partager',
    videoCopyLink: 'Copier le Lien',
    videoLinkCopied: 'Lien Copié !',
    videoDownload: 'Télécharger',
    videoMinutes: 'minutes',
    galleryTitle: 'Galerie Vidéo',
    gallerySubtitle: 'Explorez les vidéos éducatives partagées par la communauté',
    gallerySearch: 'Rechercher par sujet...',
    galleryEmpty: 'Aucune vidéo dans la galerie pour le moment',
    galleryEmptyDesc: 'Soyez le premier à partager une vidéo éducative !',
    galleryCreateVideo: 'Créer une Vidéo',
    navGallery: 'Galerie'
  }
};

export const t = (key, language = 'pt') => {
  return translations[language]?.[key] || translations['pt'][key] || key;
};
